var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetreadyforexam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 287.766,
    height: 160.59,
    viewBox: "0 0 287.766 160.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#e0e0e0;}.c{fill:#e6e6e6;}.d{fill:#f0f0f0;}.e{fill:#e9e9e9;}.f{fill:#f4f4f4;}.au,.eh,.g,.i,.l,.n,.o,.s,.u,.y{fill:#fff;}.h{fill:#2e353a;}.ai,.eb,.ed,.i,.k{opacity:0.2;}.j{fill:#407bff;}.ae,.ag,.ah,.ai,.au,.ba,.bb,.bd,.be,.bh,.bj,.dx,.eb,.ed,.eq,.fg,.fh,.fi,.fp,.fq,.fr,.fu,.k,.p,.r,.s,.v{isolation:isolate;}.l,.m,.p{opacity:0.4;}.n{font-size:5px;font-family:SegoeUI, Segoe UI;}.o{opacity:0.7;}.ae,.ah,.ba,.bb,.be,.bh,.bj,.fp,.q,.r,.y{opacity:0.5;}.s{opacity:0.6;}.t{fill:#b97964;}.bd,.u{opacity:0.8;}.v{opacity:0.1;}.w,.z{fill:none;}.w{stroke:#2e353a;stroke-miterlimit:10;stroke-width:2px;}.x{fill:#a24e3f;}.z{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.aa,.ab,.ac,.ad,.ae,.af,.ag,.ah,.ai,.aj,.am,.an,.ap,.aq,.ar,.au,.av,.aw,.ax,.ay,.az,.ba,.bb,.bc,.bd,.be,.bf,.bg,.bj,.bk,.bl,.bm,.bn,.dw,.dx,.dy,.dz,.ea,.eb,.eg,.eh,.ej,.ek,.el,.em,.en,.eo,.ep,.eq,.er,.es,.et,.eu,.ev,.ew,.ex,.ey,.ez,.fa,.fb,.fc,.fd,.fe,.ff,.fg,.fh,.fi,.fj,.fk,.fl,.fm,.fn,.fo,.fp,.fq,.fr,.fs,.ft,.fu{fill-rule:evenodd;}.aa{fill:url(#a);}.ab{fill:#aa330f;}.ac{fill:url(#b);}.ad{fill:#ca4f0f;}.ae,.ag,.ai,.ee{fill:#6a1760;}.ae,.ag,.ah,.ai,.ba,.bb,.be,.bh,.dx,.eb,.ed,.fp,.fu{mix-blend-mode:multiply;}.af{fill:url(#c);}.ag,.dx,.fu{opacity:0.3;}.ah{fill:#b61760;}.aj{fill:url(#d);}.ak{fill:#e54d98;}.al{fill:#c9a4ac;}.am{fill:url(#e);}.an{fill:url(#f);}.ao{fill:url(#g);}.ap{fill:url(#h);}.aq{fill:url(#i);}.ar{fill:url(#j);}.as{fill:#835d9d;}.at{fill:#00f1ff;}.au,.bd,.bj,.eq{mix-blend-mode:soft-light;}.av{fill:#c7d3ff;opacity:0.39;}.aw{fill:url(#k);}.ax{fill:url(#l);}.ay{fill:url(#m);}.az{fill:url(#n);}.ba{fill:#400079;}.bb{fill:url(#o);}.bc{fill:url(#p);}.bd,.bj{fill:#fbf9fa;}.be,.bi,.fu{fill:#9a2463;}.bf{fill:url(#q);}.bg{fill:url(#r);}.bk{fill:url(#s);}.bl{fill:url(#t);}.bm{fill:url(#u);}.bn{fill:url(#v);}.bo{fill:url(#w);}.bp{fill:url(#x);}.bq{fill:url(#y);}.br{fill:url(#z);}.bs{fill:url(#aa);}.bt{fill:url(#ab);}.bu{fill:url(#ac);}.bv{fill:url(#ad);}.bw{fill:url(#ae);}.bx{fill:url(#af);}.by{fill:url(#ag);}.bz{fill:url(#ah);}.ca{fill:url(#ai);}.cb{fill:url(#aj);}.cc{fill:url(#ak);}.cd{fill:url(#al);}.ce{fill:url(#am);}.cf{fill:url(#an);}.cg{fill:url(#ao);}.ch{fill:url(#ap);}.ci{fill:url(#aq);}.cj{fill:url(#ar);}.ck{fill:url(#as);}.cl{fill:url(#at);}.cm{fill:url(#au);}.cn{fill:url(#av);}.co{fill:url(#aw);}.cp{fill:url(#ax);}.cq{fill:url(#ay);}.cr{fill:url(#az);}.cs{fill:url(#ba);}.ct{fill:url(#bb);}.cu{fill:url(#bc);}.cv{fill:url(#bd);}.cw{fill:url(#be);}.cx{fill:url(#bf);}.cy{fill:url(#bg);}.cz{fill:url(#bh);}.da{fill:url(#bi);}.db{fill:url(#bj);}.dc{fill:url(#bk);}.dd{fill:url(#bl);}.de{fill:url(#bm);}.df{fill:url(#bn);}.dg{fill:url(#bo);}.dh{fill:url(#bp);}.di{fill:url(#bq);}.dj{fill:url(#br);}.dk{fill:url(#bs);}.dl{fill:url(#bt);}.dm{fill:url(#bu);}.dn{fill:url(#bv);}.do{fill:url(#bw);}.dp{fill:url(#bx);}.dq{fill:url(#by);}.dr{fill:url(#bz);}.ds{fill:url(#ca);}.dt{fill:url(#cb);}.du{fill:url(#cc);}.dv{fill:url(#cd);}.dw{fill:url(#ce);}.dx{fill:#953345;}.dy{fill:url(#cf);}.dz{fill:url(#cg);}.ea{fill:url(#ch);}.eb{fill:#3117d6;}.ec{fill:#ff3b60;}.ef,.eg{fill:#967ea5;}.ei{fill:url(#ci);}.ej{fill:url(#cj);}.ek{fill:url(#ck);}.el{fill:url(#cl);}.em{fill:#ff9b54;}.en{fill:url(#cm);}.eo{fill:url(#cn);}.ep{fill:url(#co);}.eq{fill:#b5a4bf;}.er{fill:url(#cp);}.es{fill:url(#cq);}.et{fill:url(#cr);}.eu{fill:url(#cs);}.ev{fill:url(#ct);}.ew{fill:url(#cu);}.ex{fill:url(#cv);}.ey{fill:url(#cw);}.ez,.fa{opacity:0.72;}.ez{fill:url(#cx);}.fa{fill:url(#cy);}.fb{fill:url(#cz);}.fc{fill:url(#da);}.fd{fill:url(#dd);}.fe{fill:url(#de);}.ff{fill:#ffe74c;}.fg,.fh,.fi,.fq,.fr{mix-blend-mode:screen;}.fg{fill:url(#df);}.fh{fill:url(#dh);}.fi{fill:url(#di);}.fj{fill:url(#dj);}.fk{fill:url(#dk);}.fl{fill:#ffaa68;}.fm{fill:url(#dl);}.fn{fill:url(#dm);}.fo{fill:#ff3e79;}.fp{fill:#9c4c7a;}.fq{fill:url(#dn);}.fr{fill:url(#do);}.fs{fill:url(#dp);}.ft{fill:url(#dq);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.484,
    y1: 0.55,
    x2: 0.484,
    y2: -0.298,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.021,
    y1: -0.053,
    x2: 0.982,
    y2: -0.053,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3e6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#efe3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#e4dae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#dbd3e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.017,
    y1: -0.219,
    x2: 1.001,
    y2: -0.219,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1.36,
    y1: 3.165,
    x2: 1.36,
    y2: 2.198,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#ffdac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff3c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c72a16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#ba2244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.514,
    y1: 1.45,
    x2: 0.473,
    y2: 0.007,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#2a0e51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0.55,
    cy: 0.027,
    r: 0.92,
    gradientTransform: "translate(0.224) scale(0.552 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#471371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#20003b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0.466,
    cy: 0.948,
    r: 1.22,
    gradientTransform: "translate(0.233 7.283) scale(0.499 0.725)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#26a9ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0.65,
    cy: 0.549,
    r: 5.553,
    gradientTransform: "translate(0.616 52.562) scale(0.051 1.327)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aea8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#8c74b1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0.5,
    cy: 0.5,
    r: 0.6,
    gradientTransform: "translate(0.135 0.021) scale(0.747 0.958)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0.5,
    cy: 0.5,
    r: 1.113,
    gradientTransform: "translate(0.332) scale(0.335 1)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0.65,
    cy: 0.549,
    r: 2.419,
    gradientTransform: "translate(0.573 44.652) scale(0.118 1.327)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0.65,
    cy: 0.549,
    r: 2.376,
    gradientTransform: "translate(0.571 43.822) scale(0.12 1.327)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#bdafd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#7036a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#e03347"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0.5,
    cy: 0.5,
    r: 0.955,
    gradientTransform: "translate(0.301) scale(0.399 1)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0.5,
    cy: 0.5,
    r: 0.693,
    gradientTransform: "translate(0.203) scale(0.594 1)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.005,
    y1: 0.378,
    x2: 1.005,
    y2: 0.378,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0.23,
    cy: 0.451,
    r: 4.741,
    gradientTransform: "matrix(0.095, -0.064, 0.006, 0.998, 0.214, 0.016)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d47d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#713592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.006,
    y1: 0.361,
    x2: 1.007,
    y2: 0.361,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0.499,
    cy: 0.484,
    r: 4.195,
    gradientTransform: "matrix(0.084, -0.064, 0.005, 0.998, 0.463, 0.033)",
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.083,
    y1: 0.266,
    x2: 0.986,
    y2: 0.287,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#ff4c06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#ff0e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#ff12c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.045,
    y1: 0.255,
    x2: 1.019,
    y2: 0.278,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.014,
    y1: 0.245,
    x2: 1.045,
    y2: 0.269,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -0.022,
    y1: 0.24,
    x2: 1.075,
    y2: 0.265,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: -0.057,
    y1: 0.219,
    x2: 1.094,
    y2: 0.246,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: -0.89,
    y1: -3.393,
    x2: 35.795,
    y2: -3.261,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: -3.375,
    y1: -3.711,
    x2: 39.889,
    y2: -3.558,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 1.274,
    y1: -2.681,
    x2: 25.221,
    y2: -2.581,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: -20.238,
    y1: -8.555,
    x2: 112.235,
    y2: -8.2,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -1.804,
    y1: -2.201,
    x2: 28.805,
    y2: -2.103,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: -4.435,
    y1: -2.712,
    x2: 35.253,
    y2: -2.587,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: -43.785,
    y1: 2.403,
    x2: 4.082,
    y2: 2.596,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: -67.843,
    y1: 2.841,
    x2: 9.348,
    y2: 3.123,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -28.438,
    y1: 2.14,
    x2: 1.095,
    y2: 2.278,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: -39.531,
    y1: 1.589,
    x2: 7.148,
    y2: 1.748,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -34.975,
    y1: 1.685,
    x2: 4.629,
    y2: 1.826,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: -102.921,
    y1: 2.802,
    x2: 21.101,
    y2: 3.173,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: -63.775,
    y1: 1.558,
    x2: 13.733,
    y2: 1.751,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: -91.726,
    y1: 1.82,
    x2: 22.613,
    y2: 2.105,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: -43.65,
    y1: 1.465,
    x2: 7.697,
    y2: 1.612,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: -145.217,
    y1: 1.729,
    x2: 45.343,
    y2: 2.145,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: -58.391,
    y1: 1.09,
    x2: 15.655,
    y2: 1.242,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: -66.451,
    y1: 1.02,
    x2: 19.724,
    y2: 1.187,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: -83.911,
    y1: 0.877,
    x2: 30.218,
    y2: 1.084,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: -113.011,
    y1: 0.867,
    x2: 43.341,
    y2: 1.16,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: -56.123,
    y1: 0.892,
    x2: 18.571,
    y2: 1.041,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: -87.748,
    y1: 0.459,
    x2: 40.457,
    y2: 0.641,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: -223.094,
    y1: 0.058,
    x2: 105.872,
    y2: 0.943,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: -77.679,
    y1: 0.549,
    x2: 34.141,
    y2: 0.706,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: -162.174,
    y1: -0.132,
    x2: 91.678,
    y2: 0.181,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: -113.988,
    y1: 0.297,
    x2: 61.499,
    y2: 0.468,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: -138.617,
    y1: 0.123,
    x2: 76.756,
    y2: 0.355,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: -8.825,
    y1: -2.372,
    x2: 37.668,
    y2: -2.245,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: -3.395,
    y1: -2.051,
    x2: 31.071,
    y2: -1.951,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: -7.654,
    y1: -2.865,
    x2: 42.767,
    y2: -2.725,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: -12.208,
    y1: -2.182,
    x2: 41.206,
    y2: -2.053,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: -106.128,
    y1: -16.427,
    x2: 308.483,
    y2: -15.672,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: -8.04,
    y1: -1.785,
    x2: 33.941,
    y2: -1.68,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: -24.011,
    y1: -2.92,
    x2: 58.542,
    y2: -2.736,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: -11.537,
    y1: -1.636,
    x2: 40.004,
    y2: -1.53,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: -16.375,
    y1: -2.274,
    x2: 46.311,
    y2: -2.131,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: -21.82,
    y1: -1.709,
    x2: 46.665,
    y2: -1.58,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: -15.063,
    y1: -1.272,
    x2: 36.786,
    y2: -1.172,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: -33.878,
    y1: -1.783,
    x2: 60.597,
    y2: -1.635,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: -136.52,
    y1: -121.594,
    x2: 257.892,
    y2: -114.186,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: -44.298,
    y1: -2.349,
    x2: 73.462,
    y2: -2.159,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: -175.28,
    y1: -23.131,
    x2: 233.875,
    y2: -21.28,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: -37.366,
    y1: -0.99,
    x2: 55.394,
    y2: -0.88,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: -44.776,
    y1: -1.198,
    x2: 62.617,
    y2: -1.07,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: -74.382,
    y1: -1.18,
    x2: 87.4,
    y2: -1.036,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: -90.399,
    y1: -1.657,
    x2: 102.949,
    y2: -1.469,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: -104.482,
    y1: -0.668,
    x2: 102.092,
    y2: -0.556,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: -197.229,
    y1: -25.54,
    x2: 188.034,
    y2: -22.548,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: -92.892,
    y1: -0.458,
    x2: 92.467,
    y2: -0.367,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: -197.87,
    y1: -0.951,
    x2: 156.809,
    y2: -0.657,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: -193.898,
    y1: -0.56,
    x2: 152.679,
    y2: -0.32,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: -229.369,
    y1: -7.974,
    x2: 153.809,
    y2: -6.008,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: -146.288,
    y1: 0.008,
    x2: 94.836,
    y2: 0.197,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: -152.903,
    y1: -0.114,
    x2: 100.406,
    y2: 0.095,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 0.006,
    y1: 0.3,
    x2: 1.008,
    y2: 0.3,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 3.026,
    y1: -2.495,
    x2: 3.026,
    y2: -3.267,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 3.889,
    y1: -4.519,
    x2: 3.889,
    y2: -6.437,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#e03347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#cf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#c2b5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#d2c5de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#e4d7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#efe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e6ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#cf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3e6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#efe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#e4d7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#d2c5de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#c2b5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 0,
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7179ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e85fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#cf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: -0.177,
    y1: 0.327,
    x2: 0.832,
    y2: 0.327,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#2a0e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#561f7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: -0.178,
    y1: 0.352,
    x2: 0.832,
    y2: 0.352,
    xlinkHref: "#cr"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ct",
    cx: 0.499,
    cy: 0.523,
    r: 2.085,
    gradientTransform: "matrix(0.17, 0.137, -0.024, 0.991, 0.133, -0.018)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86478a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5a2b82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cu",
    cx: 0.496,
    cy: 0.508,
    r: 1.814,
    gradientTransform: "matrix(0.195, 0.137, -0.027, 0.991, 0.131, -0.018)",
    xlinkHref: "#ct"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: -0.178,
    y1: 0.317,
    x2: 0.832,
    y2: 0.317,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#985997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#5a2b82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: -0.36,
    y1: 0.137,
    x2: 0.649,
    y2: 0.137,
    xlinkHref: "#cr"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 0.113,
    y1: 0.944,
    x2: 0.113,
    y2: 0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#cec4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e1ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: -0.104,
    y1: 4.471,
    x2: -0.104,
    y2: 5.424,
    xlinkHref: "#cx"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#dd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdc8ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdc8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab6f55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 0.464,
    y1: 2.016,
    x2: 0.464,
    y2: 1.018,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: -1.125,
    y1: -0.494,
    x2: -1.125,
    y2: -1.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#c93347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: -25.054,
    y1: -28.071,
    x2: -24.898,
    y2: -29.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#2a0e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50306c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dm",
    cx: 0.465,
    cy: 0.519,
    r: 0.387,
    gradientTransform: "matrix(0.71, 0.805, -0.963, 0.593, -18.174, 10.874)",
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: -0.982,
    y1: -0.257,
    x2: -0.982,
    y2: -1.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd6327"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd6327"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dp",
    cx: 0.193,
    cy: 0.315,
    r: 0.637,
    gradientTransform: "translate(0.166) scale(0.668 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#7179ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584ede"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dq",
    cx: 0.5,
    cy: 0.5,
    r: 0.913,
    gradientTransform: "translate(0.29) scale(0.42 1)",
    xlinkHref: "#dp"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2540.771 -2926.201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2540.771 2918.805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 231.569,
    height: 0.116,
    transform: "translate(0 151.652)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.34,
    height: 0.116,
    transform: "translate(193.026 159.107)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.026,
    height: 0.116,
    transform: "translate(149.374 160.364)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8.889,
    height: 0.116,
    transform: "translate(183.674 154.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.005,
    height: 0.116,
    transform: "translate(24.296 155.584)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.933,
    height: 0.116,
    transform: "translate(48.424 155.584)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 43.385,
    height: 0.116,
    transform: "translate(60.889 157.54)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.565 69.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M392.953,291.226s-3.559-6.966.507-13.832,5.246-8.484,2.653-9.891S392.332,273,392.332,273a14.017,14.017,0,0,1-.381-9.714c1.8-4.968,2.936-13.059.472-13.927s-.471,10.094-2.609,13.83a29.5,29.5,0,0,1-2.091-8.149c-.3-3.99.166-10.361-1.78-12s-3.192-.5-1.28,8.3a82.939,82.939,0,0,1,1.9,15.963s-4.223-11.55-7.058-11.887-2.831,3.4-.4,6.648,7.105,9.056,7.873,12.047c0,0-4.636-8.692-8.806-6.028s3.63,7.914,7.106,9.811,5.891,13.789,5.891,13.789Z",
    transform: "translate(-376.969 -242.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M399.818,297.27s3.466-7.012-.692-13.823-5.358-8.413-2.785-9.854,3.855,5.442,3.855,5.442a14.019,14.019,0,0,0,.251-9.718c-1.871-4.943-3.11-13.018-.658-13.919s.605,10.086,2.793,13.794a29.494,29.494,0,0,0,1.982-8.176c.242-3.994-.3-10.358,1.619-12.018s3.185-.546,1.391,8.284a82.94,82.94,0,0,0-1.684,15.987s4.069-11.605,6.9-11.98,2.876,3.366.494,6.642-6.984,9.15-7.711,12.151c0,0,4.519-8.753,8.725-6.145s-3.524,7.962-6.974,9.905-5.705,13.867-5.705,13.867Z",
    transform: "translate(-386.644 -245.598)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.528 46.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M406.74,343.187H378.11l2.317,18.376h24Z",
    transform: "translate(-378.11 -343.187)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.498)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 52.157,
    height: 57.714
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 47.703,
    height: 53.261,
    transform: "translate(2.295 2.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M235.482,97,222,147.491V120.157L228.169,97Z",
    transform: "translate(-219.705 -94.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M244.53,97l-14.218,53.261H227.63L241.848,97Z",
    transform: "translate(-222.728 -94.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M313.023,128.36V155.7L310,167.1H302.69Z",
    transform: "translate(-263.024 -111.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.853,
    height: 57.714,
    transform: "translate(25.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 50.25,
    height: 1.853,
    transform: "translate(0.906 11.711)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 52.157,
    height: 57.714
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 47.703,
    height: 53.261,
    transform: "translate(2.295 2.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M81.482,97,68,147.491V120.157L74.169,97Z",
    transform: "translate(-65.705 -94.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M90.53,97,76.311,150.261H73.63L87.848,97Z",
    transform: "translate(-68.728 -94.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M159.023,128.36V155.7L156,167.1H148.69Z",
    transform: "translate(-109.024 -111.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 1.853,
    height: 57.714,
    transform: "translate(25.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 50.25,
    height: 1.853,
    transform: "translate(0.906 11.711)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.492 54.253)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M284.043,222.781h-59.9a2.546,2.546,0,0,1-2.574-2.793l7.552-96.886a3.072,3.072,0,0,1,3.009-2.794h59.9A2.546,2.546,0,0,1,294.6,123.1l-7.552,96.886A3.072,3.072,0,0,1,284.043,222.781Z",
    transform: "translate(-221.558 -116.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M284.043,222.781h-59.9a2.546,2.546,0,0,1-2.574-2.793l7.552-96.886a3.072,3.072,0,0,1,3.009-2.794h59.9A2.546,2.546,0,0,1,294.6,123.1l-7.552,96.886A3.072,3.072,0,0,1,284.043,222.781Z",
    transform: "translate(-221.558 -116.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M314.643,124.641H285.957a.89.89,0,0,1-.9-.976L285.5,118a1.074,1.074,0,0,1,1.052-.977h28.686a.89.89,0,0,1,.9.977l-.441,5.664A1.074,1.074,0,0,1,314.643,124.641Z",
    transform: "translate(-260.272 -114.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M314.643,124.641H285.957a.89.89,0,0,1-.9-.976L285.5,118a1.074,1.074,0,0,1,1.052-.977h28.686a.89.89,0,0,1,.9.977l-.441,5.664A1.074,1.074,0,0,1,314.643,124.641Z",
    transform: "translate(-260.272 -114.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M324.025,114.511h-4.488l.175-2.246a2.47,2.47,0,0,1,2.419-2.246h0a2.046,2.046,0,0,1,2.069,2.246Z",
    transform: "translate(-281.297 -110.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M324.025,114.511h-4.488l.175-2.246a2.47,2.47,0,0,1,2.419-2.246h0a2.046,2.046,0,0,1,2.069,2.246Z",
    transform: "translate(-281.297 -110.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M289.515,225.054H231.855l7.357-94.386h57.661Z",
    transform: "translate(-227.836 -122.609)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.48 5.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M315.085,131.454H296.656a2.1,2.1,0,0,1-2.12-2.3l.234-3a2.533,2.533,0,0,1,2.479-2.3h18.428a2.1,2.1,0,0,1,2.12,2.3l-.234,3A2.533,2.533,0,0,1,315.085,131.454Zm-17.9-6.819a1.673,1.673,0,0,0-1.637,1.52l-.234,3a1.386,1.386,0,0,0,1.4,1.519h18.428a1.673,1.673,0,0,0,1.637-1.519l.234-3a1.387,1.387,0,0,0-1.4-1.52Z",
    transform: "translate(-294.529 -123.854)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M315.085,131.454H296.656a2.1,2.1,0,0,1-2.12-2.3l.234-3a2.533,2.533,0,0,1,2.479-2.3h18.428a2.1,2.1,0,0,1,2.12,2.3l-.234,3A2.533,2.533,0,0,1,315.085,131.454Zm-17.9-6.819a1.673,1.673,0,0,0-1.637,1.52l-.234,3a1.386,1.386,0,0,0,1.4,1.519h18.428a1.673,1.673,0,0,0,1.637-1.519l.234-3a1.387,1.387,0,0,0-1.4-1.52Z",
    transform: "translate(-294.529 -123.854)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M319.6,124.164H303.985a.489.489,0,0,1-.495-.537l.122-1.562a.59.59,0,0,1,.578-.537H319.8a.49.49,0,0,1,.495.537l-.122,1.562A.591.591,0,0,1,319.6,124.164Z",
    transform: "translate(-271.512 -117.036)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.479 17.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M310.342,158.549H266.63l.372-4.772h43.712Z",
    transform: "translate(-258.518 -153.777)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.204 10.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M287.844,181.089h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.914 -179.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M287.135,190.185h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.482 -185.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M286.426,199.281h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.049 -190.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M285.717,208.378h-29.1l.1-1.232h29.1Z",
    transform: "translate(-256.617 -196.496)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.526 8.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M361.555,191.739H349.682l.926-11.882h11.873Z",
    transform: "translate(-349.682 -178.194)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 4.281, 4.985)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.803 28.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M284.253,227.154h-29.1l.1-1.232h29.1Z",
    transform: "translate(-254.323 -225.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M283.544,236.25h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.891 -231.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M282.835,245.347h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.459 -237.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M282.126,254.443h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.027 -242.561)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.125 26.494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M357.964,237.8H346.092l.926-11.882H358.89Z",
    transform: "translate(-346.092 -224.259)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 4.281, 4.985)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.401 46.136)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M280.663,273.219h-29.1l.1-1.232h29.1Z",
    transform: "translate(-250.733 -271.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M279.954,282.316h-29.1l.1-1.232h29.1Z",
    transform: "translate(-250.301 -277.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M279.245,291.412h-29.1l.1-1.232h29.1Z",
    transform: "translate(-249.868 -283.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M278.536,300.508h-29.1l.1-1.232h29.1Z",
    transform: "translate(-249.436 -288.626)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.724 44.473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M354.374,283.87H342.5l.926-11.882H355.3Z",
    transform: "translate(-342.501 -270.325)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 4.281, 4.985)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M277.072,319.285h-29.1l.1-1.232h29.1Z",
    transform: "translate(-247.142 -318.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276.363,328.381h-29.1l.1-1.232h29.1Z",
    transform: "translate(-246.71 -323.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M275.654,337.477h-29.1l.1-1.232h29.1Z",
    transform: "translate(-246.278 -329.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M274.945,346.573h-29.1l.1-1.232h29.1Z",
    transform: "translate(-245.845 -334.691)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.322 62.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M350.783,329.935H338.91l.926-11.882h11.873Z",
    transform: "translate(-338.91 -316.39)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 4.281, 4.985)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M310.342,158.549H266.63l.372-4.772h43.712Z",
    transform: "translate(-258.518 -153.777)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.204 10.179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M287.844,181.089h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.914 -179.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M287.135,190.185h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.482 -185.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M286.426,199.281h-29.1l.1-1.232h29.1Z",
    transform: "translate(-257.049 -190.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M285.717,208.378h-29.1l.1-1.232h29.1Z",
    transform: "translate(-256.617 -196.496)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M361.555,191.739H349.682l.926-11.882h11.873Z",
    transform: "translate(-309.156 -169.679)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.803 28.157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M284.253,227.154h-29.1l.1-1.232h29.1Z",
    transform: "translate(-254.323 -225.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M283.544,236.25h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.891 -231.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M282.835,245.347h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.459 -237.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M282.126,254.443h-29.1l.1-1.232h29.1Z",
    transform: "translate(-253.027 -242.561)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M357.964,237.8H346.092l.926-11.882H358.89Z",
    transform: "translate(-306.967 -197.765)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.401 46.136)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M280.663,273.219h-29.1l.1-1.232h29.1Z",
    transform: "translate(-250.733 -271.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M279.954,282.316h-29.1l.1-1.232h29.1Z",
    transform: "translate(-250.301 -277.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M279.245,291.412h-29.1l.1-1.232h29.1Z",
    transform: "translate(-249.868 -283.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M278.536,300.508h-29.1l.1-1.232h29.1Z",
    transform: "translate(-249.436 -288.626)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M354.374,283.87H342.5l.926-11.882H355.3Z",
    transform: "translate(-304.777 -225.852)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M277.072,319.285h-29.1l.1-1.232h29.1Z",
    transform: "translate(-247.142 -318.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M276.363,328.381h-29.1l.1-1.232h29.1Z",
    transform: "translate(-246.71 -323.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M275.654,337.477h-29.1l.1-1.232h29.1Z",
    transform: "translate(-246.278 -329.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M274.945,346.573h-29.1l.1-1.232h29.1Z",
    transform: "translate(-245.845 -334.691)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M350.783,329.935H338.91l.926-11.882h11.873Z",
    transform: "translate(-302.588 -253.938)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.205 76.44)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M183.059,257v12.755a9.767,9.767,0,0,1-2.708,6.75l-11.907,12.452h6.741l12.367-12.17a9.767,9.767,0,0,0,2.916-6.961V257Z",
    transform: "translate(-130.999 -239.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M190.472,257v12.824a9.373,9.373,0,0,1-.241,2.135,9.683,9.683,0,0,1-2.677,4.826l-12.366,12.171H168.45l11.9-12.454a9.744,9.744,0,0,0,2.709-6.748V257Z",
    transform: "translate(-131.001 -239.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M207.41,257v12.824a9.373,9.373,0,0,1-.241,2.135L200,269.065V257Z",
    transform: "translate(-147.939 -239.864)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.591 50.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M121.042,329l-9.973,38.007a1.616,1.616,0,0,1-1.562,1.206H91.682a.959.959,0,0,1-.928-1.2L100.733,329H98.818l-9.857,37.539a2.813,2.813,0,0,0,2.72,3.526h17.826a3.47,3.47,0,0,0,3.354-2.588L122.958,329Z",
    transform: "translate(-88.868 -329)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(0.591 50.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M121.042,329l-9.973,38.007a1.616,1.616,0,0,1-1.562,1.206H91.682a.959.959,0,0,1-.928-1.2L100.733,329H98.818l-9.857,37.539a2.813,2.813,0,0,0,2.72,3.526h17.826a3.47,3.47,0,0,0,3.354-2.588L122.958,329Z",
    transform: "translate(-88.868 -329)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.148 49.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M152.43,369.457l-10.906-41.59-1.792.469,10.783,41.12Z",
    transform: "translate(-139.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.379 49.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M200.43,369.457l-10.906-41.59-1.792.469,10.783,41.12Z",
    transform: "translate(-187.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(24.148 49.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M152.43,369.457l-10.906-41.59-1.792.469,10.783,41.12Z",
    transform: "translate(-139.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(46.379 49.957)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M200.43,369.457l-10.906-41.59-1.792.469,10.783,41.12Z",
    transform: "translate(-187.732 -327.867)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M108.772,329h1.917l-1.505,5.729-1.774-.542Z",
    transform: "translate(-98.231 -278.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M141.522,327.87,144,337.323l-2.079-.63-2.191-8.355Z",
    transform: "translate(-115.583 -277.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M154.856,329h1.913l-3.14,12-1.778-.542Z",
    transform: "translate(-122.09 -278.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M193.9,344.759l-2.089-.639-4.08-15.58,1.792-.509Z",
    transform: "translate(-141.352 -277.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M96.443,271.118l-8.681-46.883-.117-.709a3.046,3.046,0,0,1,.626-2.506A2.844,2.844,0,0,1,90.5,220h18.748a4,4,0,0,1,3.731,3.206l.139.791,8.657,46.775-1.822.337-8.683-46.918-.113-.657a2.135,2.135,0,0,0-1.908-1.681H90.5a1.01,1.01,0,0,0-.806.353,1.215,1.215,0,0,0-.223,1l.131.776,8.663,46.8Z",
    transform: "translate(-87.591 -220)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M96.443,271.118l-8.681-46.883-.117-.709a3.046,3.046,0,0,1,.626-2.506A2.844,2.844,0,0,1,90.5,220h18.748a4,4,0,0,1,3.731,3.206l.139.791,8.657,46.775-1.822.337-8.683-46.918-.113-.657a2.135,2.135,0,0,0-1.908-1.681H90.5a1.01,1.01,0,0,0-.806.353,1.215,1.215,0,0,0-.223,1l.131.776,8.663,46.8Z",
    transform: "translate(-87.591 -220)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.836 46.468)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M5,0H35.262a5,5,0,0,1,5,5v.414a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(1.485)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 43.232,
    height: 2.707,
    rx: 1.353
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 43.232,
    height: 2.707,
    rx: 1.353
  }))), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M116.972,247.989H93.431L89.92,229h23.537l3.483,18.813Z",
    transform: "translate(-88.842 -224.832)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.667 45.38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M188.917,166.688s-2.959-6.874-3.217-7.609.046-4.456-.178-5.119-3.666-1.1-4.393-1.013-.084,5.834.214,6.291a8.538,8.538,0,0,0,1.322,1.26l2.616,7.89Z",
    transform: "translate(-150.09 -152.937)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.217 8.368)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M164.091,189.363c2.021.319,10.286,1.511,12.133.281,1.493-.995-2.71-17.117-2.71-17.117l3.739-1.522s8.879,19.55,4.135,24.016c-2.41,2.269-9.179,2.844-18.919,2.844Z",
    transform: "translate(-162.47 -171.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M164.091,189.363c2.021.319,10.286,1.511,12.133.281,1.493-.995-2.71-17.117-2.71-17.117l3.739-1.522s8.879,19.55,4.135,24.016c-2.41,2.269-9.179,2.844-18.919,2.844Z",
    transform: "translate(-162.47 -171.005)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M168.08,222.761c-1.436.042-2.969.06-4.58.06l1.389-5.321A11.93,11.93,0,0,1,168.08,222.761Z",
    transform: "translate(-140.806 -187.598)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "w",
    x2: 9.803,
    y2: 10.364,
    transform: "translate(35.508 38.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M176,245.481s7.481-.232,8.256-.309,4.017-1.93,4.712-2.007,2.547,2.856,2.779,3.55-5.249,2.547-5.789,2.47a8.541,8.541,0,0,1-1.7-.664l-8.256.972Z",
    transform: "translate(-147.516 -201.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M166.5,399.075l3.689-.506.511-8.77-3.684.51Z",
    transform: "translate(-142.418 -280.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M169.426,407.472l-4.168-.26a.264.264,0,0,0-.291.234v0l-.409,3.288a.658.658,0,0,0,.608.7c1.456.067,2.154.026,3.989.126a34.515,34.515,0,0,0,4.9.157c1.554-.151,1.363-1.682.692-1.755a10.247,10.247,0,0,1-4.694-2.237A1.044,1.044,0,0,0,169.426,407.472Z",
    transform: "translate(-141.373 -289.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M176.619,408.258a4.557,4.557,0,0,1-.984-.195.079.079,0,0,1-.062-.069.1.1,0,0,1,.039-.087c.124-.076,1.221-.726,1.666-.522a.329.329,0,0,1,.185.259.463.463,0,0,1-.136.476A1,1,0,0,1,176.619,408.258Zm.586-.7c-.237-.11-.874.163-1.322.41.656.172,1.145.182,1.331.022a.319.319,0,0,0,.081-.3.157.157,0,0,0-.09-.127Z",
    transform: "translate(-147.287 -289.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M175.655,407.011a.052.052,0,0,1-.037,0,.1.1,0,0,1-.043-.071c0-.032-.016-1.119.378-1.459a.464.464,0,0,1,.377-.1.334.334,0,0,1,.3.282c.058.409-.544,1.152-.927,1.348A.056.056,0,0,1,175.655,407.011Zm.6-1.445a.251.251,0,0,0-.189.067,1.915,1.915,0,0,0-.315,1.161,1.823,1.823,0,0,0,.7-1.087c0-.051-.033-.113-.156-.136Z",
    transform: "translate(-147.288 -288.464)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M167.285,390.315l3.685-.506-.293,5.013-3.68.323Z",
    transform: "translate(-142.683 -280.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M140.473,290.539l-.9-5.639-20.684-1.237s-2.2,11.734-.509,14.861c3.016,5.581,19.275,2.764,24.032,3.313-2.844,11.629-2.566,34.356-2.566,34.356l6.794.519s5.228-24.489,6.285-36.125C153.639,292.734,147.133,292.93,140.473,290.539Z",
    transform: "translate(-116.239 -223.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M163.626,393.86l8.165.537.7-3.5-8.971-.417Z",
    transform: "translate(-140.816 -280.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M184.881,392.943l3.714.273,2.327-8.471-3.71-.268Z",
    transform: "translate(-152.284 -277.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M187.351,401.217l-4.022-1.122a.264.264,0,0,0-.333.168v0l-1.085,3.131a.657.657,0,0,0,.449.808c1.41.369,2.1.475,3.876.955a34.6,34.6,0,0,0,4.758,1.173c1.551.177,1.684-1.362,1.043-1.573a10.242,10.242,0,0,1-4.124-3.166A1.043,1.043,0,0,0,187.351,401.217Z",
    transform: "translate(-150.675 -285.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M194.944,403.664a4.582,4.582,0,0,1-.921-.4.079.079,0,0,1-.046-.081.1.1,0,0,1,.056-.077c.137-.048,1.346-.456,1.739-.164a.33.33,0,0,1,.127.291.464.464,0,0,1-.233.437A1,1,0,0,1,194.944,403.664Zm.719-.563c-.209-.157-.888-.023-1.379.125.606.305,1.082.416,1.3.3a.319.319,0,0,0,.143-.281.158.158,0,0,0-.062-.143Z",
    transform: "translate(-157.167 -287.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M194.04,402.058a.048.048,0,0,1-.037,0,.1.1,0,0,1-.028-.078c.009-.032.218-1.1.674-1.349a.466.466,0,0,1,.39-.016.333.333,0,0,1,.233.338c-.028.412-.772,1.014-1.187,1.125A.056.056,0,0,1,194.04,402.058Zm.891-1.288a.249.249,0,0,0-.2.026c-.275.148-.465.73-.55,1.07.382-.176.879-.646.914-.917.007-.051-.008-.118-.124-.165Z",
    transform: "translate(-157.166 -285.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M188.421,384.477l3.709.273-1.331,4.842-3.666-.451Z",
    transform: "translate(-153.493 -277.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M163.521,337.747l-6.539-1.922s3.9-22.036,7.864-29.678c-.3-.1-.69-.222-1.176-.366-.875-.264-2.038-.593-3.4-.973-9.5-2.635-28.765-7.577-28.765-7.577l8.8-8.211s35.05,5.345,35.777,14.58C176.424,308.041,163.521,337.747,163.521,337.747Z",
    transform: "translate(-123.626 -225.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M184.7,386.539l7.874,2.226,1.412-3.274-8.687-2.276Z",
    transform: "translate(-152.186 -276.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M170.294,309.736c-.875-.264-2.038-.593-3.4-.973.273-2.242.278-4.812-.8-6.123-2.144-2.612-7.66-4.145-10.8-4.7-2.626-.463-11.449-1.385-11.449-1.385a69.362,69.362,0,0,1,23.152,2.316C172.777,300.561,171.651,306.216,170.294,309.736Z",
    transform: "translate(-130.251 -229.95)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.14 25.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M140.818,208.887s3,11.115-.5,35.055c-6.535-.139-17.516-.394-20.7-.463-.079-3.335,2.381-19.674-.5-35.435a43.013,43.013,0,0,1,6.266-.621,79.871,79.871,0,0,1,9.221.2A40.485,40.485,0,0,1,140.818,208.887Z",
    transform: "translate(-119.12 -207.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M140.818,208.887s3,11.115-.5,35.055c-6.535-.139-17.516-.394-20.7-.463-.079-3.335,2.381-19.674-.5-35.435a43.013,43.013,0,0,1,6.266-.621,79.871,79.871,0,0,1,9.221.2A40.485,40.485,0,0,1,140.818,208.887Z",
    transform: "translate(-119.12 -207.371)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M127.443,236.666c-1.839-.408-4.062-2.191-5.882-3.951-.014-3.131-.153-6.461-.491-9.856C123.645,226.672,130.62,237.365,127.443,236.666Z",
    transform: "translate(-118.027 -190.476)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.884)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M116.639,208.824c-7.08,2.551,5.348,21.726,9.207,23.7s23.466-2.161,23.466-2.161l-.772-3.966s-17.348.443-18.947.038-5.4-8.577-7.583-12.436A12.344,12.344,0,0,0,116.639,208.824Z",
    transform: "translate(-114.499 -208.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M116.639,208.824c-7.08,2.551,5.348,21.726,9.207,23.7s23.466-2.161,23.466-2.161l-.772-3.966s-17.348.443-18.947.038-5.4-8.577-7.583-12.436A12.344,12.344,0,0,0,116.639,208.824Z",
    transform: "translate(-114.499 -208.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.652 43.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M185,246l1,5.264,1.853-.633L187.161,246Z",
    transform: "translate(-185 -246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M185,246l1,5.264,1.853-.633L187.161,246Z",
    transform: "translate(-185 -246)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.746 7.368)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M185.609,172.519l4.983-1.972-.969-1.7L185.2,170.4Z",
    transform: "translate(-185.204 -168.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M185.609,172.519l4.983-1.972-.969-1.7L185.2,170.4Z",
    transform: "translate(-185.204 -168.846)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M130.241,206.6s.132,2.164,4.381,4.248l2.938-2.124s.838,5.424,1.364,9.476a65.649,65.649,0,0,0-.594-8.973l2.248.8s-1.915-3.286-5.169-4.039A6.66,6.66,0,0,0,130.241,206.6Z",
    transform: "translate(-122.95 -181.296)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M133.785,185.164c.519,2.978.982,8.424-1.135,10.36l6.2,1.721,3.018-1.522c-3.293-.861-3.154-3.316-2.529-5.609Z",
    transform: "translate(-124.243 -170.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M139.834,189.524l3.288,2.932a9.709,9.709,0,0,0-.32,1.63c-1.26-.208-2.964-1.635-3.071-2.959A4.355,4.355,0,0,1,139.834,189.524Z",
    transform: "translate(-128.028 -172.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M143.954,165.287c-1.348,1.464-.185,3.135,4.117,5.169,1.024-2.255.4-6.021-.991-6.678S145.131,164.018,143.954,165.287Z",
    transform: "translate(-130.027 -158.638)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M130.941,169.069c1.093,3.876,1.538,6.2,3.955,7.785,3.64,2.385,8.1-.463,8.188-4.59.074-3.705-1.723-9.425-5.9-10.152a5.493,5.493,0,0,0-6.238,6.956Z",
    transform: "translate(-123.206 -157.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M144.356,176.04c.069.32.3.542.5.5s.32-.338.25-.658-.292-.542-.5-.5S144.31,175.721,144.356,176.04Z",
    transform: "translate(-130.522 -164.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M152.2,174.349c.069.32.3.542.5.5s.324-.338.255-.662-.3-.542-.5-.5S152.127,174.03,152.2,174.349Z",
    transform: "translate(-134.726 -164.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M149.73,176a11.693,11.693,0,0,0,2.121,2.4,1.889,1.889,0,0,1-1.468.616Z",
    transform: "translate(-133.413 -165.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M141.413,173.222a.181.181,0,0,1-.222-.255,1.9,1.9,0,0,1,1.362-1.107.185.185,0,0,1,.216.149l0,.013a.2.2,0,0,1-.162.218h0a1.513,1.513,0,0,0-1.065.885A.2.2,0,0,1,141.413,173.222Z",
    transform: "translate(-128.82 -163.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M153.313,170.458a.2.2,0,0,1-.195-.069,1.528,1.528,0,0,0-1.241-.621.193.193,0,0,1-.037-.384,1.917,1.917,0,0,1,1.579.769.19.19,0,0,1-.03.267l0,0A.232.232,0,0,1,153.313,170.458Z",
    transform: "translate(-134.454 -161.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M128.918,168.778c1.973.232,2.177,2.26.232,6.6-2.246-1.047-4.224-4.316-3.589-5.715S127.2,168.579,128.918,168.778Z",
    transform: "translate(-120.373 -161.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M128.35,181.858a3.83,3.83,0,0,0,2.265,1.853c1.288.375,1.945-.773,1.6-2-.31-1.1-1.357-2.626-2.654-2.464A1.707,1.707,0,0,0,128.35,181.858Z",
    transform: "translate(-121.805 -167.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M125.79,162.516s-.979-1.262.939-3.783,6.553-3.292,10.121-2.6,1.445,4.631.172,5.287l.155-.617a10.631,10.631,0,0,1-4.4,1.2l.7-.656S127.873,162.8,125.79,162.516Z",
    transform: "translate(-120.427 -154.523)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.027 14.646)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M147.491,184.681a10.021,10.021,0,0,0-.132,1.44c-.084.013-.168.026-.253.035-1.145.152-1.726-.156-2.023-.543a1.49,1.49,0,0,1-.271-.651,1.446,1.446,0,0,1-.02-.4,5.441,5.441,0,0,0,2.308.167C147.341,184.706,147.491,184.681,147.491,184.681Z",
    transform: "translate(-144.786 -184.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M147.1,184.727l-.05.424a3.432,3.432,0,0,1-2.238-.188,1.446,1.446,0,0,1-.02-.4A5.441,5.441,0,0,0,147.1,184.727Z",
    transform: "translate(-144.786 -184.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M147.45,187.354c-1.145.152-1.726-.156-2.023-.543a3.7,3.7,0,0,1,1.3.083A1.393,1.393,0,0,1,147.45,187.354Z",
    transform: "translate(-145.13 -185.757)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.291 23.454)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M132.44,203.577a26.924,26.924,0,0,0,5.12,3.091,4.63,4.63,0,0,0,.484-2.824l2.533,1.765a6.252,6.252,0,0,1,0,3.245l-3.018-1.723-2.856,2.084s-4.22-1.222-4.463-3.785Z",
    transform: "translate(-130.241 -203.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M132.44,203.577a26.924,26.924,0,0,0,5.12,3.091,4.63,4.63,0,0,0,.484-2.824l2.533,1.765a6.252,6.252,0,0,1,0,3.245l-3.018-1.723-2.856,2.084s-4.22-1.222-4.463-3.785Z",
    transform: "translate(-130.241 -203.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.831 47.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 47.246,
    height: 2.439,
    rx: 1.167,
    transform: "translate(0.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M200.24,255.417v1.357c0,.3-.083.542-.38.542H153.695c-.3,0-.695-.241-.695-.542v-1.357c0-.3.394-.417.695-.417H199.86C200.157,255,200.24,255.12,200.24,255.417Z",
    transform: "translate(-153 -254.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M172.452,255.417v1.357c0,.3-.1.542-.4.542H153.695c-.3,0-.695-.241-.695-.542v-1.357c0-.3.394-.417.695-.417h18.359C172.35,255,172.452,255.12,172.452,255.417Z",
    transform: "translate(-153 -254.938)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.124 7.396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.029 11.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M152.179,101.56a8.859,8.859,0,1,0-12,10.512,2.529,2.529,0,0,1,1.335,1.287l.3.684,8.524-2.322-.085-.741a2.556,2.556,0,0,1,.506-1.8A8.92,8.92,0,0,0,152.179,101.56Z",
    transform: "translate(-134.773 -95.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M151.886,126.008s-1.282-4.028-3.551-5.81l1.257-.343.1-1.93,2.048,2.968-.166-3.612,2.024,3.293.205-1.867,1.793-.489a10.291,10.291,0,0,0-.5,7",
    transform: "translate(-142.054 -106.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M157.148,134.562a3.273,3.273,0,1,0,3.584,2.384A3.059,3.059,0,0,0,157.148,134.562Z",
    transform: "translate(-145.706 -116.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M156.887,136.954l-3.036.827a2.983,2.983,0,0,1-3.6-1.881l-1-2.809a.43.43,0,0,1,.292-.558l8.379-2.283a.429.429,0,0,1,.534.333l.567,2.927A2.983,2.983,0,0,1,156.887,136.954Z",
    transform: "translate(-142.537 -113.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M156.887,136.954l-3.036.827a2.983,2.983,0,0,1-3.6-1.881l-1-2.809a.43.43,0,0,1,.292-.558l8.379-2.283a.429.429,0,0,1,.534.333l.567,2.927A2.983,2.983,0,0,1,156.887,136.954Z",
    transform: "translate(-142.537 -113.929)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.187,97.473a14.564,14.564,0,0,0-2.517-.236,10.487,10.487,0,0,0-1.255.069c-.206.032-.414.057-.615.109-.1.026-.2.041-.3.077l-.294.094-.333.107.2-.292a11.02,11.02,0,0,0,1.33-2.689,8.408,8.408,0,0,0,.348-1.45,6.807,6.807,0,0,0,.067-.737,5.793,5.793,0,0,0-.012-.735,5.633,5.633,0,0,0-.1-.723l-.087-.354-.115-.345a4.567,4.567,0,0,0-.3-.659,5.552,5.552,0,0,0-.387-.614,5.966,5.966,0,0,0-.472-.554l-.256-.26-.278-.239c-.178-.166-.389-.3-.584-.445s-.417-.262-.624-.394l-.482-.307.513-.246c.246-.118.506-.263.753-.408s.492-.3.73-.468A12.326,12.326,0,0,0,116.47,84.7c.212-.195.415-.4.612-.6s.379-.428.554-.652.337-.457.484-.7a6.875,6.875,0,0,0,.406-.739,6.537,6.537,0,0,0,.316-.776l.119-.4.087-.408a5.457,5.457,0,0,0,.091-.828,6.429,6.429,0,0,0-.016-.834,6.992,6.992,0,0,0-.131-.829l-.095-.41-.129-.4c-.076-.272-.2-.528-.3-.792s-.251-.511-.376-.767l-.661-1.366,1.267.816c.224.144.48.292.729.425s.508.264.768.382a12.7,12.7,0,0,0,1.594.611c.271.082.545.156.82.214a7.6,7.6,0,0,0,.829.139,6.325,6.325,0,0,0,.829.05,6.083,6.083,0,0,0,.818-.054l.4-.071.391-.1a4.964,4.964,0,0,0,.741-.308,2.8,2.8,0,0,0,.346-.2,2.2,2.2,0,0,0,.328-.23,5.937,5.937,0,0,0,.6-.537,6.17,6.17,0,0,0,.514-.636,5.819,5.819,0,0,0,.438-.7c.145-.236.242-.5.366-.754.108-.26.2-.528.3-.792l.582-1.517.285,1.584a6.275,6.275,0,0,0,.2.764,7.28,7.28,0,0,0,.29.758,6.844,6.844,0,0,0,.813,1.392,5.725,5.725,0,0,0,1.124,1.125,5.013,5.013,0,0,0,.669.426,6.175,6.175,0,0,0,.726.324,6.368,6.368,0,0,0,.772.209,6.286,6.286,0,0,0,.8.113,7.111,7.111,0,0,0,.814.016c.272,0,.545-.035.818-.06s.544-.087.817-.128l.809-.193.8-.241.79-.283,1.1-.393-.633.976c-.112.173-.232.379-.337.577s-.205.407-.3.616a7.451,7.451,0,0,0-.431,1.288,5.484,5.484,0,0,0-.152,1.328,4.026,4.026,0,0,0,.226,1.291l.124.3.152.29a4.075,4.075,0,0,0,.383.536,4.145,4.145,0,0,0,.465.477,5.057,5.057,0,0,0,.538.409,5.894,5.894,0,0,0,.585.352c.2.111.415.2.622.3l.649.248.666.207.479.149-.392.3a6.259,6.259,0,0,0-.734.668,7.178,7.178,0,0,0-.644.77,4.517,4.517,0,0,0-.279.416,3.506,3.506,0,0,0-.243.437,2.717,2.717,0,0,0-.2.456,2.868,2.868,0,0,0-.155.473c-.033.162-.088.321-.1.486l-.045.5c0,.166.019.332.026.5a2.155,2.155,0,0,0,.082.493,2.977,2.977,0,0,0,.13.485l.19.468a2.627,2.627,0,0,0,.239.447l.259.439.094.16H142.8a7.963,7.963,0,0,0-2.028.269,4.593,4.593,0,0,0-.955.375c-.077.038-.146.09-.22.134a1.389,1.389,0,0,0-.208.151,1.617,1.617,0,0,0-.194.17l-.177.189.167-.2a1.6,1.6,0,0,1,.186-.181,1.378,1.378,0,0,1,.2-.164c.072-.049.139-.106.215-.148a4.692,4.692,0,0,1,.951-.434,7.639,7.639,0,0,1,2.061-.365l-.082.161-.287-.443a2.8,2.8,0,0,1-.267-.455l-.219-.485a3.141,3.141,0,0,1-.158-.509,2.357,2.357,0,0,1-.108-.524c-.016-.178-.044-.357-.049-.535l.027-.539a5.331,5.331,0,0,1,.092-.53,3.19,3.19,0,0,1,.147-.518,3.079,3.079,0,0,1,.2-.5,3.93,3.93,0,0,1,.242-.479,4.875,4.875,0,0,1,.281-.456,7.594,7.594,0,0,1,1.443-1.585l.088.449-.7-.2-.69-.245c-.224-.1-.453-.188-.672-.3a6.4,6.4,0,0,1-.646-.367,5.631,5.631,0,0,1-.608-.44,4.8,4.8,0,0,1-.542-.529,4.7,4.7,0,0,1-.459-.613l-.187-.337-.154-.353a4.68,4.68,0,0,1-.3-1.5,6.163,6.163,0,0,1,.133-1.5,8.233,8.233,0,0,1,.438-1.425c.093-.23.2-.455.3-.678a7.01,7.01,0,0,1,.371-.661l.468.583-.824.3-.841.261c-.284.076-.572.142-.859.212-.292.048-.582.111-.878.145s-.591.072-.892.073a7.814,7.814,0,0,1-.9-.011,7.068,7.068,0,0,1-.9-.12,7.226,7.226,0,0,1-.886-.233,6.983,6.983,0,0,1-.844-.368,5.843,5.843,0,0,1-.781-.489,6.568,6.568,0,0,1-1.305-1.284,7.728,7.728,0,0,1-.928-1.558,8.154,8.154,0,0,1-.329-.842,6.872,6.872,0,0,1-.238-.895l.867.067c-.107.287-.2.578-.319.862-.134.279-.239.569-.4.838a6.7,6.7,0,0,1-.489.8,7.135,7.135,0,0,1-.59.741,5.93,5.93,0,0,1-.716.637,2.929,2.929,0,0,1-.4.273,3.6,3.6,0,0,1-.419.238,5.947,5.947,0,0,1-.892.361l-.465.119c-.156.031-.314.053-.471.079a6.933,6.933,0,0,1-.943.055,7.092,7.092,0,0,1-.933-.063,8.445,8.445,0,0,1-.912-.16c-.3-.066-.6-.149-.887-.24a13.486,13.486,0,0,1-1.7-.667c-.275-.127-.545-.267-.811-.411s-.523-.3-.793-.472l.607-.551c.132.278.278.549.4.833s.244.568.326.87l.138.445.1.457a7.768,7.768,0,0,1,.138.928,7.354,7.354,0,0,1,.011.942,6.254,6.254,0,0,1-.112.937l-.1.461-.138.451a7.288,7.288,0,0,1-.36.867,6.577,6.577,0,0,1-.46.813c-.168.262-.355.509-.547.75s-.4.468-.615.689-.438.429-.668.63a13.007,13.007,0,0,1-1.458,1.1c-.254.166-.515.323-.779.473s-.53.288-.822.419l.031-.553c.219.146.443.283.656.437s.427.31.617.5l.295.266.273.29a6.4,6.4,0,0,1,.5.62,6.022,6.022,0,0,1,.411.687,5.1,5.1,0,0,1,.314.736l.118.383.086.39a6.134,6.134,0,0,1,.09.79,7.7,7.7,0,0,1-.537,3.071,10.987,10.987,0,0,1-.647,1.407,10.639,10.639,0,0,1-.831,1.305l-.135-.185.314-.087c.1-.033.211-.045.316-.068.211-.046.426-.063.638-.088a9.906,9.906,0,0,1,1.279-.017A14.693,14.693,0,0,1,120.187,97.473Z",
    transform: "translate(-113.118 -70.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M120.187,97.473a14.564,14.564,0,0,0-2.517-.236,10.487,10.487,0,0,0-1.255.069c-.206.032-.414.057-.615.109-.1.026-.2.041-.3.077l-.294.094-.333.107.2-.292a11.02,11.02,0,0,0,1.33-2.689,8.408,8.408,0,0,0,.348-1.45,6.807,6.807,0,0,0,.067-.737,5.793,5.793,0,0,0-.012-.735,5.633,5.633,0,0,0-.1-.723l-.087-.354-.115-.345a4.567,4.567,0,0,0-.3-.659,5.552,5.552,0,0,0-.387-.614,5.966,5.966,0,0,0-.472-.554l-.256-.26-.278-.239c-.178-.166-.389-.3-.584-.445s-.417-.262-.624-.394l-.482-.307.513-.246c.246-.118.506-.263.753-.408s.492-.3.73-.468A12.326,12.326,0,0,0,116.47,84.7c.212-.195.415-.4.612-.6s.379-.428.554-.652.337-.457.484-.7a6.875,6.875,0,0,0,.406-.739,6.537,6.537,0,0,0,.316-.776l.119-.4.087-.408a5.457,5.457,0,0,0,.091-.828,6.429,6.429,0,0,0-.016-.834,6.992,6.992,0,0,0-.131-.829l-.095-.41-.129-.4c-.076-.272-.2-.528-.3-.792s-.251-.511-.376-.767l-.661-1.366,1.267.816c.224.144.48.292.729.425s.508.264.768.382a12.7,12.7,0,0,0,1.594.611c.271.082.545.156.82.214a7.6,7.6,0,0,0,.829.139,6.325,6.325,0,0,0,.829.05,6.083,6.083,0,0,0,.818-.054l.4-.071.391-.1a4.964,4.964,0,0,0,.741-.308,2.8,2.8,0,0,0,.346-.2,2.2,2.2,0,0,0,.328-.23,5.937,5.937,0,0,0,.6-.537,6.17,6.17,0,0,0,.514-.636,5.819,5.819,0,0,0,.438-.7c.145-.236.242-.5.366-.754.108-.26.2-.528.3-.792l.582-1.517.285,1.584a6.275,6.275,0,0,0,.2.764,7.28,7.28,0,0,0,.29.758,6.844,6.844,0,0,0,.813,1.392,5.725,5.725,0,0,0,1.124,1.125,5.013,5.013,0,0,0,.669.426,6.175,6.175,0,0,0,.726.324,6.368,6.368,0,0,0,.772.209,6.286,6.286,0,0,0,.8.113,7.111,7.111,0,0,0,.814.016c.272,0,.545-.035.818-.06s.544-.087.817-.128l.809-.193.8-.241.79-.283,1.1-.393-.633.976c-.112.173-.232.379-.337.577s-.205.407-.3.616a7.451,7.451,0,0,0-.431,1.288,5.484,5.484,0,0,0-.152,1.328,4.026,4.026,0,0,0,.226,1.291l.124.3.152.29a4.075,4.075,0,0,0,.383.536,4.145,4.145,0,0,0,.465.477,5.057,5.057,0,0,0,.538.409,5.894,5.894,0,0,0,.585.352c.2.111.415.2.622.3l.649.248.666.207.479.149-.392.3a6.259,6.259,0,0,0-.734.668,7.178,7.178,0,0,0-.644.77,4.517,4.517,0,0,0-.279.416,3.506,3.506,0,0,0-.243.437,2.717,2.717,0,0,0-.2.456,2.868,2.868,0,0,0-.155.473c-.033.162-.088.321-.1.486l-.045.5c0,.166.019.332.026.5a2.155,2.155,0,0,0,.082.493,2.977,2.977,0,0,0,.13.485l.19.468a2.627,2.627,0,0,0,.239.447l.259.439.094.16H142.8a7.963,7.963,0,0,0-2.028.269,4.593,4.593,0,0,0-.955.375c-.077.038-.146.09-.22.134a1.389,1.389,0,0,0-.208.151,1.617,1.617,0,0,0-.194.17l-.177.189.167-.2a1.6,1.6,0,0,1,.186-.181,1.378,1.378,0,0,1,.2-.164c.072-.049.139-.106.215-.148a4.692,4.692,0,0,1,.951-.434,7.639,7.639,0,0,1,2.061-.365l-.082.161-.287-.443a2.8,2.8,0,0,1-.267-.455l-.219-.485a3.141,3.141,0,0,1-.158-.509,2.357,2.357,0,0,1-.108-.524c-.016-.178-.044-.357-.049-.535l.027-.539a5.331,5.331,0,0,1,.092-.53,3.19,3.19,0,0,1,.147-.518,3.079,3.079,0,0,1,.2-.5,3.93,3.93,0,0,1,.242-.479,4.875,4.875,0,0,1,.281-.456,7.594,7.594,0,0,1,1.443-1.585l.088.449-.7-.2-.69-.245c-.224-.1-.453-.188-.672-.3a6.4,6.4,0,0,1-.646-.367,5.631,5.631,0,0,1-.608-.44,4.8,4.8,0,0,1-.542-.529,4.7,4.7,0,0,1-.459-.613l-.187-.337-.154-.353a4.68,4.68,0,0,1-.3-1.5,6.163,6.163,0,0,1,.133-1.5,8.233,8.233,0,0,1,.438-1.425c.093-.23.2-.455.3-.678a7.01,7.01,0,0,1,.371-.661l.468.583-.824.3-.841.261c-.284.076-.572.142-.859.212-.292.048-.582.111-.878.145s-.591.072-.892.073a7.814,7.814,0,0,1-.9-.011,7.068,7.068,0,0,1-.9-.12,7.226,7.226,0,0,1-.886-.233,6.983,6.983,0,0,1-.844-.368,5.843,5.843,0,0,1-.781-.489,6.568,6.568,0,0,1-1.305-1.284,7.728,7.728,0,0,1-.928-1.558,8.154,8.154,0,0,1-.329-.842,6.872,6.872,0,0,1-.238-.895l.867.067c-.107.287-.2.578-.319.862-.134.279-.239.569-.4.838a6.7,6.7,0,0,1-.489.8,7.135,7.135,0,0,1-.59.741,5.93,5.93,0,0,1-.716.637,2.929,2.929,0,0,1-.4.273,3.6,3.6,0,0,1-.419.238,5.947,5.947,0,0,1-.892.361l-.465.119c-.156.031-.314.053-.471.079a6.933,6.933,0,0,1-.943.055,7.092,7.092,0,0,1-.933-.063,8.445,8.445,0,0,1-.912-.16c-.3-.066-.6-.149-.887-.24a13.486,13.486,0,0,1-1.7-.667c-.275-.127-.545-.267-.811-.411s-.523-.3-.793-.472l.607-.551c.132.278.278.549.4.833s.244.568.326.87l.138.445.1.457a7.768,7.768,0,0,1,.138.928,7.354,7.354,0,0,1,.011.942,6.254,6.254,0,0,1-.112.937l-.1.461-.138.451a7.288,7.288,0,0,1-.36.867,6.577,6.577,0,0,1-.46.813c-.168.262-.355.509-.547.75s-.4.468-.615.689-.438.429-.668.63a13.007,13.007,0,0,1-1.458,1.1c-.254.166-.515.323-.779.473s-.53.288-.822.419l.031-.553c.219.146.443.283.656.437s.427.31.617.5l.295.266.273.29a6.4,6.4,0,0,1,.5.62,6.022,6.022,0,0,1,.411.687,5.1,5.1,0,0,1,.314.736l.118.383.086.39a6.134,6.134,0,0,1,.09.79,7.7,7.7,0,0,1-.537,3.071,10.987,10.987,0,0,1-.647,1.407,10.639,10.639,0,0,1-.831,1.305l-.135-.185.314-.087c.1-.033.211-.045.316-.068.211-.046.426-.063.638-.088a9.906,9.906,0,0,1,1.279-.017A14.693,14.693,0,0,1,120.187,97.473Z",
    transform: "translate(-113.118 -70.923)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2668.967 2959.657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.546 11.156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M95.2,258.2l29.285-4.72L142,251.568l-.12-1.053L124.29,252.1,95.4,257.255a7.477,7.477,0,0,1-.777-4.485L121,239.11l19.956.968-.17-.991L121.1,237.938,93.8,252.127A9.34,9.34,0,0,0,95.2,258.2Z",
    transform: "translate(-93.723 -237.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M142.272,241.5l-19.544,9.577-26.794,3.116,26.773-13.863Z",
    transform: "translate(-95.038 -239.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M95.773,262.337a7.131,7.131,0,0,0,.83,4.792l28.644-5.44,17.007-1.536a14.656,14.656,0,0,1-1.83-6.123l-18.375.685Z",
    transform: "translate(-94.876 -247.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M97.59,278.8s-1.332-3.065-1.008-4.835l-.768.223a7.648,7.648,0,0,0,.83,4.792Z",
    transform: "translate(-94.917 -259.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M160.739,254.714s.328,5.129,1.737,7.106l18.468-1.668a17,17,0,0,1-1.83-6.123Z",
    transform: "translate(-133.565 -247.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M97.828,258.536l25.62-10.525,18.253,1.022-2.065,1.5-16.3.608Z",
    transform: "translate(-96.164 -243.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M144.363,249.034l-18.253-1.022.047.407-23.851,9.591L126,251.137l16.3-.608Z",
    transform: "translate(-98.826 -243.927)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M144.363,249.63l-18.206-.615-23.851,9.591L126,251.733l16.3-.608Z",
    transform: "translate(-98.826 -244.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M168.623,270.561l.386,1.362,17.52-1.915-.121-1.053Z",
    transform: "translate(-138.251 -256.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M161.23,237.938l.3.969,19.564,1.171-.17-.992Z",
    transform: "translate(-133.856 -237.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M100.188,269.878l25.084-5.245-.039-.336Z",
    transform: "translate(-97.566 -253.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M155.857,269.817l-5.1.995,5.255-.6Z",
    transform: "translate(-127.628 -256.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M97.355,278.188l46.8-6.636-17.52,1.915Z",
    transform: "translate(-95.882 -257.922)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.918 46.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M227.533,117.288,212.471,99.5l-1.533,1.351.616,1.144a.675.675,0,1,1-1.008.9.663.663,0,0,1-.169-.41.652.652,0,0,1,.092-.383l-.567-.336-2.233,1.968.841.969a.675.675,0,1,1-1.008.9.663.663,0,0,1-.167-.41.653.653,0,0,1,.076-.356l-.513-.418-2.329,2.053.386.716a.479.479,0,0,1,.127.01.673.673,0,1,1-.79.7.678.678,0,0,1,.057-.318l-.533-.446-2.367,2.086.464.672a.765.765,0,0,1,.127.01.661.661,0,0,1,.385.214.674.674,0,0,1-1.006.9.682.682,0,0,1-.172-.409.7.7,0,0,1,0-.119v0l-.761-.416-2.059,1.815.4.714a.655.655,0,0,1,.169.009.675.675,0,1,1-.622,1.113.668.668,0,0,1-.169-.41.613.613,0,0,1,.014-.18c-.206-.13-.472-.3-.7-.444l-2.244,1.977.332.677a.679.679,0,1,1-.443.675.64.64,0,0,1,.088-.375l-.6-.429-1.4,1.238,15.9,17.2a2.352,2.352,0,0,0,3.257.125l12.768-11.348,2.109-1.874A2.355,2.355,0,0,0,227.533,117.288Z",
    transform: "translate(-193.248 -99.499)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.933 5.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 24.148,
    height: 0.139,
    transform: "matrix(0.747, -0.664, 0.664, 0.747, 0, 16.043)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.353 7.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 24.148,
    height: 0.139,
    transform: "matrix(0.747, -0.664, 0.664, 0.747, 0, 16.043)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.149 9.243)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 24.148,
    height: 0.139,
    transform: "translate(0 16.043) rotate(-41.633)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.757 11.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 24.148,
    height: 0.139,
    transform: "matrix(0.747, -0.664, 0.664, 0.747, 0, 16.043)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.365 12.862)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 24.148,
    height: 0.139,
    transform: "matrix(0.747, -0.664, 0.664, 0.747, 0, 16.043)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.974 15.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 23.871,
    height: 0.139,
    transform: "matrix(0.756, -0.655, 0.655, 0.756, 0, 15.628)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.581 16.516)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 23.87,
    height: 0.139,
    transform: "translate(0 16.007) rotate(-42.112)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.678 18.396)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "al",
    width: 23.216,
    height: 0.139,
    transform: "matrix(0.744, -0.668, 0.668, 0.744, 0, 15.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.214 3.47)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 0.139,
    height: 25.567,
    transform: "translate(0 0.091) rotate(-40.643)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M221,353.621l1.536,4.244,99.124.532,2.386-4.241Z",
    transform: "translate(-205.607 -238.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M214.513,320.4l-23.273,4.452,1.247,4.081,115.862.568.96-3.966-25.144-5.657Z",
    transform: "translate(-183.863 -213.926)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.021 98.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M402.143,301.495a1.917,1.917,0,0,1-1.346-.675c-.331-.338-.707-.811-1.142-1.358-1.757-2.209-4.407-5.543-8.494-5.543h-.066c-8.276.072-10.394,6.125-10.415,6.186l-.029.085-.089,0a19.119,19.119,0,0,0-3.3.234l-1.3.209a14.071,14.071,0,0,1-4.386.369c-.68-.04-1.708-.1-3.449-.143l.006-.24c1.745.043,2.776.1,3.457.143a13.919,13.919,0,0,0,4.333-.366l1.3-.209a19.767,19.767,0,0,1,3.26-.239c.292-.748,2.7-6.2,10.609-6.266h.069c4.2,0,6.9,3.387,8.682,5.633.431.542.8,1.011,1.126,1.34a1.427,1.427,0,0,0,2.254.088,7.275,7.275,0,0,0,1.6-2.877,5.515,5.515,0,0,1-.806-1.907,2.067,2.067,0,0,1,.617-2.028c.426-.382.674-.24.783-.121.4.437.23,2.251-.336,4.006a8.155,8.155,0,0,0,3,2.852,13.044,13.044,0,0,0,5.341.474l.03.239a13.026,13.026,0,0,1-5.46-.49,8.175,8.175,0,0,1-3.012-2.782,7.367,7.367,0,0,1-1.6,2.808A1.824,1.824,0,0,1,402.143,301.495Zm2.992-7.573a.584.584,0,0,0-.336.186,1.841,1.841,0,0,0-.541,1.807,5.022,5.022,0,0,0,.667,1.643c.5-1.63.636-3.245.32-3.587A.144.144,0,0,0,405.135,293.921Z",
    transform: "translate(-368.126 -293.679)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.369 58.117)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M339.454,144.6l-.593,9.041-.353,5.345-1.172,17.853-.148,2.255a2.164,2.164,0,0,1-2.156,2H272.795a2.159,2.159,0,0,1-2.157-2.055l-1.459-34.25a2.165,2.165,0,0,1,2.161-2.27l7.981-.029,5.1-.018,20.08-.075,16.358-.057,5.194-.021,11.249-.039A2.16,2.16,0,0,1,339.454,144.6Z",
    transform: "translate(-269.176 -142.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M276.881,147.975l66.386-.24-1.766,32.91-63.78.224Z",
    transform: "translate(-274.806 -146.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M274.382,273.753h66.7v1.59a1.813,1.813,0,0,1-1.813,1.813H276.195a1.813,1.813,0,0,1-1.813-1.813Z",
    transform: "translate(-272.98 -238.341)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.273 37.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M466.246,281.976H448.4v-1.2h17.847Zm-17.727-.12h17.607v-.96H448.519Z",
    transform: "translate(-448.399 -280.776)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.035 37.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "as",
    width: 0.12,
    height: 1.08
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.687 37.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "as",
    width: 0.12,
    height: 1.08
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.159 37.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "as",
    width: 0.12,
    height: 1.08
  })), /*#__PURE__*/React.createElement("rect", {
    className: "at",
    width: 2.921,
    height: 0.853,
    transform: "translate(3.386 36.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M448.92,281.272l.29.27,4.093-.012.2-.28Z",
    transform: "translate(-400.506 -243.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M466.622,281.273l.238.271,4.093-.012.161-.28Z",
    transform: "translate(-413.441 -243.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M483.822,281.272l.223.286,3.927-.006.2-.28Z",
    transform: "translate(-426.008 -243.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M500.421,281.3l.29.27,3.2,0,.2-.28Z",
    transform: "translate(-438.136 -243.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M274.382,273.753l.093.271,66.609-.03v-.241Z",
    transform: "translate(-272.98 -238.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M420.544,142.52l.88,1.129,27.331-.24-1.44,25.17,1.147.279,1.674-24.145a2.274,2.274,0,0,0-2.269-2.433Z",
    transform: "translate(-379.774 -142.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M272.763,235.667l1.347.928.393,9.33h-1.3Z",
    transform: "translate(-271.797 -210.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M386.02,286.388l.952,5.691h5.946l.722-5.691Z",
    transform: "translate(-354.549 -247.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M381.76,307.555h-1.9l-.982,3.841h11.466l-.82-3.841H381.76Z",
    transform: "translate(-349.332 -263.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M338.833,312.544l.66,1h2.581l13.279-.71,13.672.71h3.822v-1l-15.166-3.021h-7.214Z",
    transform: "translate(-320.071 -264.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M352.405,305.534l-13.572,4.1h3.081l13.439-2.8,13.812,2.8h3.681l-14.421-4.071Z",
    transform: "translate(-320.071 -261.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M400.166,310.34v3.091l13.672.71.14-1Z",
    transform: "translate(-364.884 -265.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M389.223,305.534l.023,1.9,2.925-.61,3.14.637.013-1.906Z",
    transform: "translate(-356.889 -261.562)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M191.24,338.345l118.069.683-1.039,4.291-115.784-.892Z",
    transform: "translate(-183.863 -227.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M191.24,337.905l63.493-.162,54.576.845Z",
    transform: "translate(-183.863 -226.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M221,353.621l.946,2.615,52.285-1.307,48.29,1.938,1.369-2.434Z",
    transform: "translate(-205.607 -238.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M529,325.448l.587.7,4.878,1.216a17.375,17.375,0,0,0,8.818-.792Z",
    transform: "translate(-430.651 -217.995)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.353 102.804)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M529,314.661a7.852,7.852,0,0,1,6.068-4.392c4.735-.859,8.5,3.515,9.547,5.623,0,0-3.415.953-9.547.208,0,0-3.374-1.584-5.236-.931Z",
    transform: "translate(-529.004 -310.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M531.83,321.883s3-2.55,4.308-2.169.927,3.1.927,3.1A16.605,16.605,0,0,0,531.83,321.883Z",
    transform: "translate(-530.998 -316.873)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bh",
    transform: "translate(4.427 0.111)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M544.039,310.978a4.39,4.39,0,0,1,1.056.036,4.988,4.988,0,0,1,1.029.259,5.472,5.472,0,0,1,.961.456,6.082,6.082,0,0,1,.86.627l-.026-.013a9.348,9.348,0,0,0,1.736.19,6.219,6.219,0,0,0,1.729-.188l-.026.1a6.478,6.478,0,0,0-.716-.606,8.455,8.455,0,0,0-.789-.517c-.275-.153-.553-.3-.841-.432s-.583-.244-.881-.349a8.9,8.9,0,0,1,1.76.715,7.118,7.118,0,0,1,1.552,1.11l.07.069-.1.026a6.348,6.348,0,0,1-1.762.207,9.057,9.057,0,0,1-1.761-.2l-.013,0-.012-.011a6.34,6.34,0,0,0-.837-.624,5.38,5.38,0,0,0-.933-.471,5.7,5.7,0,0,0-1.008-.289A4.388,4.388,0,0,0,544.039,310.978Z",
    transform: "translate(-544.039 -310.536)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M540.586,314.409a6.65,6.65,0,0,1,1.8-1.1,4.52,4.52,0,0,1,2.687,1.643,4.112,4.112,0,0,1,.622,2.6h-2.084S543.775,314,540.586,314.409Z",
    transform: "translate(-537.176 -312.383)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M281.989,329.809l67.06-.314L335.709,327Z",
    transform: "translate(-250.169 -219.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M416.933,147.839l27.2,27.151,1.462-27.255Z",
    transform: "translate(-348.766 -88.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M278.905,227.86l11.189,11.515-10.894.038Z",
    transform: "translate(-247.916 -146.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M318.2,176.852l-1.908-34.361,49.148-.211L360.773,176.7Z",
    transform: "translate(-275.233 -84.162)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.685 101.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M281.622,322.04l-.135-1.9,70.269-3.769.193,1.982Z",
    transform: "translate(-281.487 -313.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M281.487,312.133l14-4.231,44.915-2.489,11.351,2.951Z",
    transform: "translate(-281.487 -305.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M292.789,311.29l64.7-3.466-.351-.754-9.4-2.1-43.087,2.379-11.422,3.02Z",
    transform: "translate(-289.745 -304.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M294.429,310.369l63.912-3.3-9.4-2.1-43.087,2.379Z",
    transform: "translate(-290.943 -304.969)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.143 0.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M363.246,310.8l-58.953,3.1.359-.094,58.333-3.062Z",
    transform: "translate(-304.293 -310.739)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.755 0.947)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M368.429,308.93l-53.907,2.879.32-.085,53.331-2.851Z",
    transform: "translate(-314.522 -308.873)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.622 0.623)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M372.013,307.729l-50.56,2.706.323-.086L371.8,307.67Z",
    transform: "translate(-321.453 -307.67)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.555 0.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M375.684,306.122l-47.055,2.622.349-.094,46.5-2.588Z",
    transform: "translate(-328.629 -306.064)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.224)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M379.377,305.372l-44.552,2.406.242-.066,43.948-2.356Z",
    transform: "translate(-334.825 -305.356)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.435 3.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M328.223,317.562l-.038-.064,1.544-.483-.01.039.019.03Z",
    transform: "translate(-328.184 -317.015)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.554 2.236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M339.8,314.119l-.041-.064,1.236-.4.042.064Z",
    transform: "translate(-339.763 -313.658)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.782 4.313)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M311.241,322.094l-.333.027,2.447-.754.037.064Z",
    transform: "translate(-310.908 -321.367)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.531 1.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M354.583,312.822l-.055-.06.345-.13.055.06Z",
    transform: "translate(-354.528 -312.633)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.041 3.435)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "M334.18,318.854h-.019l.009-.04-.024-.028,1.866-.679h.019l-.009.039.025.029Z",
    transform: "translate(-334.146 -318.108)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.16 2.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M345.762,315.094h-.018l.008-.039-.026-.029,1.362-.5.054.06Z",
    transform: "translate(-345.726 -314.522)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.914 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "M501.993,308.5l-1.249-.349.048-.058,1.248.349Z",
    transform: "translate(-500.744 -308.095)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.685 0.098)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "M493.186,305.985l-.716-.208.049-.058.716.208Z",
    transform: "translate(-492.47 -305.719)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.02 1.595)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M514.165,311.877l-1.887-.543.047-.058,2.166.576Z",
    transform: "translate(-512.278 -311.277)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.137 0.432)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M488,307.458l-1.272-.441.062-.055,1.272.441Z",
    transform: "translate(-486.724 -306.962)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.468 1.224)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "M496.944,310.483l-1.568-.52.03-.027-.022-.035h.026l.027.008,1.568.52Z",
    transform: "translate(-495.376 -309.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.114 0.072)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "M483.329,305.82l-.4-.143.062-.055.4.143Z",
    transform: "translate(-482.927 -305.623)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.105 1.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "M483.716,309.5l-.037,0-.787-.386.087-.046.76.372-.042.022Z",
    transform: "translate(-482.891 -309.072)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.732 0.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "M478.251,306.8l-.457-.231.086-.046.457.231Z",
    transform: "translate(-477.795 -306.521)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.995 1.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "M491.069,313.074l-1.16-.556.088-.046,1.263.592Z",
    transform: "translate(-489.908 -312.472)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.626 0.271)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "M470.191,306.549l-.216-.148.1-.037.217.148Z",
    transform: "translate(-469.974 -306.364)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.461 1.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "M477.64,311.538l-.853-.555.1-.038.854.555Z",
    transform: "translate(-476.787 -310.945)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.193 0.659)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "M472.842,308.32l-.044,0-.717-.483.1-.037.691.464-.05.018Z",
    transform: "translate(-472.081 -307.803)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.527 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "M466.384,310.418l-.488-.387.111-.033.489.387Z",
    transform: "translate(-465.896 -309.998)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.647 0.539)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "M462.929,307.638l-.3-.246.109-.033.3.246Z",
    transform: "translate(-462.628 -307.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.735 2.198)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "M471.132,314.13l-.753-.578.113-.033.844.6Z",
    transform: "translate(-470.379 -313.518)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.717 0.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "M455.9,309.24l-.433-.469.119-.026.434.468Z",
    transform: "translate(-455.463 -308.746)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.439 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "M454.476,307.684l-.048-.052.118-.026.048.052Z",
    transform: "translate(-454.428 -307.606)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.516 1.773)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "M458.967,312.534l-.539-.569.121-.026.54.569Z",
    transform: "translate(-458.427 -311.939)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.312 0.779)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "M446.678,308.528l-.145-.265.126-.016.145.265Z",
    transform: "translate(-446.534 -308.247)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.265 2.494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "M450.414,315.237l-.344-.606.131-.016.346.606Z",
    transform: "translate(-450.07 -314.614)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.717 1.517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "M448.258,311.4l-.222-.4.128-.016.223.4Z",
    transform: "translate(-448.036 -310.988)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.337 1.819)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "M361.3,312.659l-.068-.056,1.118-.495.068.056Z",
    transform: "translate(-361.236 -312.109)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.943 3.929)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "M341.273,320.692l-.065-.056,1.65-.692.066.056Z",
    transform: "translate(-341.208 -319.944)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.138 2.813)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "M353.137,316.314l-.067-.056,1.057-.456.067.056Z",
    transform: "translate(-353.07 -315.802)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.254 2.155)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "M368.431,313.9l-.08-.051.959-.5.081.051Z",
    transform: "translate(-368.35 -313.357)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.879 1.786)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "M374.445,312.066h-.024l0-.038-.039-.025.038-.02.08.051Z",
    transform: "translate(-374.384 -311.985)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.086 3.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "M360.389,317.563l-.086-.047,1.289-.65.08.051Z",
    transform: "translate(-360.303 -316.866)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.572 1.702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "M380.759,312.045l-.087-.048.564-.322.087.048Z",
    transform: "translate(-380.672 -311.674)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.68 3.613)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "M366.316,319.474l-.1-.043,1.04-.661.1.043Z",
    transform: "translate(-366.219 -318.77)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.895 2.522)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "M374.531,315.212l-.087-.048.8-.445.087.048Z",
    transform: "translate(-374.444 -314.719)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.958 1.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "M385.918,312.986l-.1-.041.692-.492.1.041Z",
    transform: "translate(-385.818 -312.453)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.351 2.841)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "M379.951,316.621l-.1-.042.067-.045.915-.631.1.041Z",
    transform: "translate(-379.851 -315.903)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.023 2.271)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "M393.6,314.251l-.113-.033.457-.43.113.033Z",
    transform: "translate(-393.484 -313.789)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.336 3.334)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "M390.931,317.743h0l.135-.008Z",
    transform: "translate(-390.931 -317.734)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.992 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "M397.192,311.156l-.112-.033.329-.317.061.012.055.017Z",
    transform: "translate(-397.08 -310.807)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.689 1.335)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "M407.211,310.349l-.119-.026.007-.009.119.026Z",
    transform: "translate(-407.092 -310.314)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.353 2.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dj",
    d: "M402.256,315.458l-.124-.024.446-.587.123.024Z",
    transform: "translate(-402.132 -314.848)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.112 1.651)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dk",
    d: "M405.074,311.994l-.122-.024.355-.484.121.024Z",
    transform: "translate(-404.952 -311.486)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.392 2.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dl",
    d: "M413.545,313.24l-.13-.013.173-.417.129.013Z",
    transform: "translate(-413.415 -312.81)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.76 1.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dm",
    d: "M414.91,310.2l-.128-.013.123-.311.125.019-.006.012Z",
    transform: "translate(-414.781 -309.877)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.86 1.411)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dn",
    d: "M422.711,311.079l-.132-.006.075-.479.131.006Z",
    transform: "translate(-422.578 -310.595)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.976 1.108)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "do",
    d: "M423.142,309.492l-.13-.006,0-.016.13.006Z",
    transform: "translate(-423.011 -309.47)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.698 2.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dp",
    d: "M422.111,314.5l-.135,0,.1-.6.133.005Z",
    transform: "translate(-421.976 -313.895)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.154 0.987)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dq",
    d: "M431.295,309.317l-.131.007-.067-.3.13-.007Z",
    transform: "translate(-431.098 -309.021)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.328 1.756)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dr",
    d: "M431.965,312.279l-.133.008-.091-.4.132-.007Z",
    transform: "translate(-431.74 -311.875)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.394 0.861)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ds",
    d: "M439.423,308.587l-.009-.022.129-.012.009.022Z",
    transform: "translate(-439.414 -308.553)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.846 2.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dt",
    d: "M441.309,313.457l-.218-.559.132-.012.219.559Z",
    transform: "translate(-441.092 -312.887)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.506 1.154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "du",
    d: "M440.013,310.125l-.183-.473.13-.011.185.473Z",
    transform: "translate(-439.829 -309.64)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "dv",
    d: "M295.385,319.112l-.072.227,63.136-3.382.132-.227Z",
    transform: "translate(-291.589 -312.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M509.339,314.037l-.084-.78,4.773-.247-.262.774Z",
    transform: "translate(-447.906 -310.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M504.456,317.476l.095.576,6.315-.355-.025-.563Z",
    transform: "translate(-444.4 -313.857)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.385 68.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dw",
    d: "M248.653,209.176s.645-1.1,6.111-1.816l-.4-7.949s-5.033.171-7.47,1.568Z",
    transform: "translate(-245.913 -194.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "M271.571,207.5l-.342-8.041.916-.046.4,7.949Z",
    transform: "translate(-263.693 -194.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "M251.637,184.542s-5.049.219-8.2.518l-.193-3.847s4.778-.339,8.2-.434Z",
    transform: "translate(-243.248 -180.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "M270.587,184.584l.906-.042-.189-3.763-.881.015Z",
    transform: "translate(-263.104 -180.779)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "dz",
    d: "M80.709,111.181a17.675,17.675,0,0,1,7.529,4.877l3.107-3.335a13.708,13.708,0,0,0-7.466-6.42Z",
    transform: "translate(3.24 -106.304)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.344 41.698)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "M375.572,123l-.435,6.661-.894,13.662-1.966,30.1-54.188.191-2.428-43.736-.33-5.925,55.676-.881Z",
    transform: "translate(-315.33 -123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eb",
    d: "M355.577,130.209l.544,4.959,31.192-.332.536-4.833Z",
    transform: "translate(-341.779 -127.602)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.764 9.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ec",
    width: 2.136,
    height: 2.136
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ec",
    width: 2.136,
    height: 2.136,
    transform: "translate(0 11.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ec",
    width: 2.136,
    height: 2.136,
    transform: "translate(0 23.492)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ec",
    width: 2.136,
    height: 2.136,
    transform: "translate(0 35.358)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.476 6.087)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M349.642,171.562a1.526,1.526,0,1,1,1.526-1.526A1.527,1.527,0,0,1,349.642,171.562Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,349.642,168.84Z",
    transform: "translate(-348.116 -168.51)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.476 17.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M349.642,205.92a1.526,1.526,0,1,1,1.526-1.526A1.528,1.528,0,0,1,349.642,205.92Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,349.642,203.2Z",
    transform: "translate(-348.116 -202.868)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.476 30.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M349.642,243.286a1.526,1.526,0,1,1,1.526-1.526A1.528,1.528,0,0,1,349.642,243.286Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,349.642,240.564Z",
    transform: "translate(-348.116 -240.234)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.722 6.087)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M429.115,171.562a1.526,1.526,0,1,1,1.526-1.526A1.528,1.528,0,0,1,429.115,171.562Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,429.115,168.84Z",
    transform: "translate(-427.589 -168.51)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.722 17.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M429.115,205.92a1.526,1.526,0,1,1,1.526-1.526A1.528,1.528,0,0,1,429.115,205.92Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,429.115,203.2Z",
    transform: "translate(-427.589 -202.868)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.722 30.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "M429.115,243.286a1.526,1.526,0,1,1,1.526-1.526A1.528,1.528,0,0,1,429.115,243.286Zm0-2.722a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,429.115,240.564Z",
    transform: "translate(-427.589 -240.234)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ed",
    transform: "translate(2.885)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 11.383,
    height: 1.428,
    transform: "translate(32.092 11.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 5.221,
    height: 1.428,
    transform: "translate(26.209 11.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 25.186,
    height: 1.428
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 10.263,
    height: 1.428,
    transform: "translate(0 2.384)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 6.764,
    height: 1.428,
    transform: "translate(32.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 15.912,
    height: 1.428,
    transform: "translate(11.365 2.384)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 2.136,
    height: 1.428,
    transform: "translate(26.209)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 2.136,
    height: 1.428,
    transform: "translate(29.294)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 25.186,
    height: 1.428,
    transform: "translate(0 11.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 10.263,
    height: 1.428,
    transform: "translate(0 14.292)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 20.065,
    height: 1.428,
    transform: "translate(11.365 14.292)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 11.383,
    height: 1.428,
    transform: "translate(32.092 35.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 5.221,
    height: 1.428,
    transform: "translate(26.209 35.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 25.186,
    height: 1.428,
    transform: "translate(0 35.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 10.263,
    height: 1.428,
    transform: "translate(0 37.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 20.065,
    height: 1.428,
    transform: "translate(11.365 37.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 11.383,
    height: 1.428,
    transform: "translate(32.092 23.492)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 5.221,
    height: 1.428,
    transform: "translate(26.209 23.492)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 25.186,
    height: 1.428,
    transform: "translate(0 23.492)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 10.263,
    height: 1.428,
    transform: "translate(0 25.876)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 20.065,
    height: 1.428,
    transform: "translate(11.365 25.876)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(5.59 7.036)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(32.961 31.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(5.59 18.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(5.59 31.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 3.684,
    height: 1.045,
    transform: "translate(5.59 33.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(32.972 18.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 9.622,
    height: 1.045,
    transform: "translate(32.972 6.222)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    width: 5.884,
    height: 1.045,
    transform: "translate(32.972 7.851)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.108 6.348)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M339.78,171.34h-.813l-.2.48h-.477l1.106-2.548h.026l1.106,2.548h-.56Zm-.16-.406-.237-.6-.246.6Z",
    transform: "translate(-338.291 -169.272)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.138 6.445)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M421.615,170.948a.542.542,0,0,1,.109.335.628.628,0,0,1-.245.548,1.023,1.023,0,0,1-.611.175h-.816v-2.451h.72a1.047,1.047,0,0,1,.613.158.527.527,0,0,1,.223.458.651.651,0,0,1-.076.321.584.584,0,0,1-.217.221A.772.772,0,0,1,421.615,170.948Zm-1.081-.392h.293a.263.263,0,0,0,.206-.081.29.29,0,0,0,.074-.2.226.226,0,0,0-.083-.188.368.368,0,0,0-.23-.065h-.26Zm.584.931a.227.227,0,0,0,.105-.2c0-.173-.138-.26-.413-.26h-.277v.533h.31A.494.494,0,0,0,421.119,171.487Z",
    transform: "translate(-420.052 -169.554)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.108 18.205)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M339.78,205.926h-.813l-.2.479h-.477l1.106-2.548h.026l1.106,2.548h-.56Zm-.16-.407-.237-.6-.246.6Z",
    transform: "translate(-338.291 -203.857)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.138 18.302)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M421.615,205.534a.542.542,0,0,1,.109.335.627.627,0,0,1-.245.548,1.023,1.023,0,0,1-.611.175h-.816V204.14h.72a1.044,1.044,0,0,1,.613.158.526.526,0,0,1,.223.458.652.652,0,0,1-.076.322.587.587,0,0,1-.217.221A.772.772,0,0,1,421.615,205.534Zm-1.081-.391h.293a.262.262,0,0,0,.206-.082.289.289,0,0,0,.074-.2.225.225,0,0,0-.083-.188.368.368,0,0,0-.23-.065h-.26Zm.584.93a.227.227,0,0,0,.105-.2c0-.173-.138-.26-.413-.26h-.277v.533h.31A.494.494,0,0,0,421.119,206.073Z",
    transform: "translate(-420.052 -204.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.108 30.909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M339.78,242.981h-.813l-.2.48h-.477l1.106-2.548h.026l1.106,2.548h-.56Zm-.16-.406-.237-.6-.246.6Z",
    transform: "translate(-338.291 -240.913)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.138 31.006)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "M421.615,242.589a.542.542,0,0,1,.109.334.628.628,0,0,1-.245.548,1.023,1.023,0,0,1-.611.175h-.816V241.2h.72a1.047,1.047,0,0,1,.613.158.527.527,0,0,1,.223.458.652.652,0,0,1-.076.322.586.586,0,0,1-.217.221A.772.772,0,0,1,421.615,242.589Zm-1.081-.392h.293a.262.262,0,0,0,.206-.082.29.29,0,0,0,.074-.2.226.226,0,0,0-.083-.188.368.368,0,0,0-.23-.065h-.26Zm.584.931a.228.228,0,0,0,.105-.205c0-.173-.138-.259-.413-.259h-.277v.533h.31A.494.494,0,0,0,421.119,243.128Z",
    transform: "translate(-420.052 -241.195)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "eg",
    d: "M351.937,171.645a.687.687,0,1,1-.687-.687A.687.687,0,0,1,351.937,171.645Z",
    transform: "translate(-345.249 -164.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eg",
    d: "M431.41,206a.687.687,0,1,1-.687-.687A.687.687,0,0,1,431.41,206Z",
    transform: "translate(-397.476 -186.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eg",
    d: "M431.41,243.574a.687.687,0,1,1-.687-.687A.687.687,0,0,1,431.41,243.574Z",
    transform: "translate(-397.476 -211.301)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.522 85.481)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "eh",
    d: "M423.424,248.408l-.836-3.722,3.527,1.861-1.908.336Z",
    transform: "translate(-422.42 -244.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ei",
    d: "M422.927,248.15l-.961-4.278,4.046,2.136-2.184.385Zm-.626-3.84.712,3.167.663-1.292,1.633-.288Z",
    transform: "translate(-421.966 -243.872)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.062 101.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M233.606,324.669l-3.4,1.109-.225,1.93-4.656.575-17.379.144a7.106,7.106,0,0,0-.483,3.072h-5.249a7.677,7.677,0,0,1,.972-3.072l-2.732-.324Z",
    transform: "translate(-199.655 -319.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ej",
    d: "M198.292,313.709a10.647,10.647,0,0,1-.622-6.3l24.652-1.6,9.2-.837v.461l-1.052.135-.066,4.088h1.043v.622l-9.525,2.74Z",
    transform: "translate(-197.497 -304.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ek",
    d: "M232.4,307.182l-8.147,1.084-23.764,1.517s-1,2.04.366,5.171l22.912-1.07,8.567-2.615Z",
    transform: "translate(-199.422 -306.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "el",
    d: "M200.777,321.946h.333s-1.232-1.863-.333-5.194h-.566A8.41,8.41,0,0,0,200.777,321.946Z",
    transform: "translate(-199.348 -313.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eg",
    d: "M201.753,316.713l.219-.014a9.55,9.55,0,0,0,.114,5.209S200.721,320.011,201.753,316.713Z",
    transform: "translate(-200.325 -313.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M204.037,311.711l22.125-1.721,8.863-1.436-8.892,1.566Z",
    transform: "translate(-202.275 -307.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M209.23,324.779l20.589-1.143,8.926-2.2-8.959,2.118Z",
    transform: "translate(-206.069 -316.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M205.52,324.159l21.533-1.282,9.214-1.957-9.232,1.811Z",
    transform: "translate(-203.359 -316.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M287.97,325.212l9.582-2.851v.622l-9.525,2.74Z",
    transform: "translate(-263.601 -317.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M233.862,304.972v.461l-1.052.135-.065,4.087-8.569,2.613h-.467a8.554,8.554,0,0,1-.017-4.766l-22.551,1.069-.444-.427,23.965-1.493v-.842Z",
    transform: "translate(-199.836 -304.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "em",
    d: "M198.143,307.407l13.754-1.319,20.1-1.118-9.2.837Z",
    transform: "translate(-197.969 -304.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "en",
    d: "M208.841,331.548s-3.321,1.1-3.321,3.7l5.223-.227a5.354,5.354,0,0,1,2.2-3.715Z",
    transform: "translate(-203.359 -324.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M229.563,331.3v.894l-.668.031v.393l-.627.025A4.211,4.211,0,0,1,229.563,331.3Z",
    transform: "translate(-219.98 -324.211)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 92.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "eo",
    d: "M182.45,286.167l24.153-1.888,14.5-1.023a9.385,9.385,0,0,0,0-6.975l-13.972-.7-24.822,1.591.085.917,1.293-.04a11.194,11.194,0,0,1,.129,6.983l-1.483.2Z",
    transform: "translate(-182.314 -275.584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ep",
    d: "M186.786,280.347,209.7,278.9s1.065,1.964.533,6.65l-23.314,1.778A13.274,13.274,0,0,0,186.786,280.347Z",
    transform: "translate(-185.408 -277.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M262.866,275.584s1.291,2.764.7,8.575l13.273-.9a9.294,9.294,0,0,0,0-6.975Z",
    transform: "translate(-238.044 -275.584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M186.786,280.347l.206.642s17.331-1.6,23.17-.527a6.592,6.592,0,0,0-.464-1.56Z",
    transform: "translate(-185.408 -277.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M188.073,286.76l18.7-1.083-18.617,1.237Z",
    transform: "translate(-186.299 -282.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M187.9,302.916l3.706-.221-3.755.423Z",
    transform: "translate(-186.146 -294.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eq",
    d: "M274.756,276.091a14.833,14.833,0,0,1,.315,8.2l2.817-.176a19.282,19.282,0,0,0-.589-7.868Z",
    transform: "translate(-246.271 -275.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eq",
    d: "M300.678,277.473s1.279,2.34.491,7.21l1.356-.086a11.863,11.863,0,0,0-.257-7.045Z",
    transform: "translate(-264.205 -276.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M206.61,287.814a6.652,6.652,0,0,0-1.545,2.376l-2.9.1a5.1,5.1,0,0,1,1.723-2.3Z",
    transform: "translate(-196.046 -284.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "er",
    d: "M200.223,287.995a13.656,13.656,0,0,0-3.354,1.287l4.337-.285a5.08,5.08,0,0,1,1.742-1.183Z",
    transform: "translate(-192.384 -284.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M229.467,295.356l10.427-.654-.016.357Z",
    transform: "translate(-214.937 -288.811)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.715 6.366)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M235.782,296.243l-.692.7-2.335.124.247-.714Z",
    transform: "translate(-231.927 -296.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "es",
    d: "M231.144,296.357l-1.075.479,2.975-.12.88-.473Z",
    transform: "translate(-230.069 -296.243)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 121.875, 21.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "et",
    d: "M21.213,3.33c-.083.6-4.959.731-10.807-.081S-.082,1.053,0,.456,4.926-.21,10.773.6,21.3,2.734,21.213,3.33Z",
    transform: "translate(0.327 29.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eu",
    d: "M0,0,.327,1.441,21.5,4.379l.707-1.3Z",
    transform: "translate(0.001 28.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ev",
    d: "M22.213,3.4c-.083.6-5.442.595-11.29-.217S-.082.916,0,.319s5.4-.312,11.251.5C17.345,1.663,22.3,2.8,22.213,3.4Z",
    transform: "translate(3.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ew",
    d: "M0,0,.327,1.441,21.5,4.379l.707-1.3Z",
    transform: "translate(3.872 0.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ex",
    d: "M22.213,3.423c-.083.6-5.122.391-11.256-.46S-.082.939,0,.341,5.123-.05,11.257.8,22.3,2.826,22.213,3.423Z",
    transform: "translate(0 27.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ey",
    d: "M0,0A161.271,161.271,0,0,0,21.177,2.938S15.365.8,0,0Z",
    transform: "translate(4.2 1.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ez",
    d: "M19.115,2.615A126.405,126.405,0,0,0,.265,0s-2.391,8.6,7.2,14.578l.374.052.373.052C19.074,11.545,19.115,2.615,19.115,2.615Z",
    transform: "translate(4.807 1.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa",
    d: "M0,12.066a84.685,84.685,0,0,0,18.851,2.615s2.391-8.6-7.2-14.578L11.273.052,10.9,0C.041,3.137,0,12.066,0,12.066Z",
    transform: "translate(1.376 16.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "M0,.023S2.04,3.249,4.4,3.8c2.3.536,7.12-3.8,7.12-3.8S4.906,2.384,0,.023Z",
    transform: "translate(8.26 11.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fc",
    d: "M0,.424A5.656,5.656,0,0,1,4.5.541C4.549,1.567,11.521.4,11.521.4A13.023,13.023,0,0,1,4.549,1.567C.8,1.062,0,.424,0,.424Z",
    transform: "translate(8.26 11.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "M1.393,1.018A7.9,7.9,0,0,0,0,5.349s4.454,1.141,8.628,1.8A63.928,63.928,0,0,0,17.3,7.8S17.967,3.25,16.011,0a7.117,7.117,0,0,1-2.6,3.1c-1.66.885-1.439.221-6.087-.5S1.393,1.018,1.393,1.018Z",
    transform: "translate(2.48 22.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fc",
    d: "M14.618,0A11.444,11.444,0,0,1,9.582,1.66C6.428,1.992,5.432.885,3.329.83A16.621,16.621,0,0,0,0,1.018a13.508,13.508,0,0,0,5.349,1.8c3.818.664,5.921,1.356,7.581.415A4.06,4.06,0,0,0,14.618,0Z",
    transform: "translate(3.872 22.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fd",
    d: "M0,3.161s5.613,1.2,8.072,0A27.036,27.036,0,0,0,4.586.04C3.756-.348.194,2.187,0,3.161Z",
    transform: "translate(8.26 21.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fe",
    d: "M0,0A16.937,16.937,0,0,1,0,5.7l.6.088A18.072,18.072,0,0,1,.743.107Z",
    transform: "translate(12.385 15.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ff",
    d: "M4.5.522A7.2,7.2,0,0,1,0,.406,5.855,5.855,0,0,1,4.5.522Z",
    transform: "translate(8.26 11.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ff",
    d: "M1.607.5,0,1.01a9.3,9.3,0,0,0,3.484.207A10.862,10.862,0,0,0,8.012,0,34.705,34.705,0,0,1,3.567.5C1.962.5,1.607.5,1.607.5Z",
    transform: "translate(11.769 11.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M0,1.8V.014a30.457,30.457,0,0,1,3.483.1L3.348,2.027S1.3,1.883,0,1.8Z",
    transform: "translate(5.072 0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M0,1.67.6,0S1.8.353,2.05.457L1.261,2Z",
    transform: "translate(23.328 2.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M.355,1.515,0,0l1.87.536V2.022A13.558,13.558,0,0,1,.355,1.515Z",
    transform: "translate(1.021 28.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M0,1.442.368.057A9.308,9.308,0,0,0,2.62,0l-.8,1.3S.667,1.433,0,1.442Z",
    transform: "translate(18.922 31.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fg",
    d: "M0,11.831A14.984,14.984,0,0,1,3.343,4.062a15.025,15.025,0,0,1,7-4.062l.832.234A32.778,32.778,0,0,0,6.612,13.191,61.988,61.988,0,0,1,0,11.831Z",
    transform: "translate(1.955 16.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fg",
    d: "M6.528,14.151A13.927,13.927,0,0,1,.867,7.213C-.55,2.761.2,0,.2,0L3.36.479S2.075,6.913,6.528,14.151Z",
    transform: "translate(5.947 2.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fh",
    d: "M10.9.3S10.6,9.347,0,12.368C0,12.368,9.191,9.561,9.391,0Z",
    transform: "translate(13.023 4.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fi",
    d: "M0,6.118A36.854,36.854,0,0,0,1.257,0a12.208,12.208,0,0,1,.656,6.118Z",
    transform: "translate(18.138 24.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eh",
    d: "M0,1.979A4.231,4.231,0,0,0,2.5,0,3.731,3.731,0,0,0,0,1.979Z",
    transform: "translate(6.102 18.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eh",
    d: "M.179,0A2.142,2.142,0,0,0,.891,2.6S1.43.547.179,0Z",
    transform: "translate(5.923 5.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eh",
    d: "M0,1.64A4.534,4.534,0,0,1,1.46,0,3.324,3.324,0,0,1,0,1.64Z",
    transform: "translate(20.195 9.969)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.41 64.241)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fj",
    d: "M535.354,237.878l-19.569-7.711-1.545.312.8.562c.3.15.318.324.031.391a1.827,1.827,0,0,1-1.064-.154.437.437,0,0,1-.226-.2.116.116,0,0,1,.066-.149l-.658-.226-2.293.524,1.005.561c.3.16.3.35.01.426a1.672,1.672,0,0,1-1.062-.156.408.408,0,0,1-.214-.214.131.131,0,0,1,.058-.154l-.6-.269-2.437.622.465.409a1.318,1.318,0,0,1,.141.023,1.464,1.464,0,0,1,.441.16c.289.171.286.377-.013.461a1.523,1.523,0,0,1-1.06-.158.4.4,0,0,1-.207-.229.154.154,0,0,1,.048-.151l-.61-.3-2.524.711.533.424c.047.006.094.014.141.023a1.323,1.323,0,0,1,.434.168c.285.182.27.4-.032.5a1.418,1.418,0,0,1-1.058-.16.412.412,0,0,1-.2-.245.17.17,0,0,1,0-.063h0l-.851-.338-2.238.688.444.463a1.493,1.493,0,0,1,.187.03,1.246,1.246,0,0,1,.43.177c.279.192.253.43-.055.532a1.326,1.326,0,0,1-1.057-.162.4.4,0,0,1-.189-.26.177.177,0,0,1,.015-.1c-.228-.105-.522-.24-.774-.36l-2.484.823.356.459a1.365,1.365,0,0,1,.384.033,1.161,1.161,0,0,1,.427.185c.27.2.235.456-.08.568a1.245,1.245,0,0,1-1.056-.165.4.4,0,0,1-.177-.276.24.24,0,0,1,.1-.217l-.65-.351-2.445.62,18.921,11.45a5.155,5.155,0,0,0,4.029-.158l15.516-7.028,2.46-.991C536.464,238.8,536.451,238.213,535.354,237.878Z",
    transform: "translate(-494.446 -230.167)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.551 2.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M518.869,245.739l-.1-.073,19.914-6.6.117.05Z",
    transform: "translate(-518.766 -239.066)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.124 3.305)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M524.712,249.549l-.1-.072,20.181-7.041.118.048Z",
    transform: "translate(-524.609 -242.437)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.162 4.068)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M532.279,252.747l-.105-.069,20.4-7.408.119.046Z",
    transform: "translate(-532.174 -245.27)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 4.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M539.1,256.053l-.106-.067,20.648-7.812.121.044Z",
    transform: "translate(-538.997 -248.174)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.859 5.597)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M546.007,259.228l-.108-.065,20.892-8.217.122.042Z",
    transform: "translate(-545.9 -250.946)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.741 6.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M552.993,262.725l-.107-.064,21.176-8.453.121.04Z",
    transform: "translate(-552.886 -254.208)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.641 7.013)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M560.054,265.261l-.111-.061,20.969-9,.125.038Z",
    transform: "translate(-559.943 -256.205)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.179 7.686)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M569.475,267.825l-.112-.058,20.681-9.066.126.036Z",
    transform: "translate(-569.362 -258.701)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.557 0.566)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M580.763,241.492l-21.135-9.2.109-.024,21.15,9.174Z",
    transform: "translate(-559.628 -232.269)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M552.994,267.353l11.8,4.811,3.014-1.365-10.6-3.21-3.778-.462Z",
    transform: "translate(-537.224 -247.671)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fk",
    d: "M562.221,213.227l20.261-16.09,1.637,2.208-20.793,15.381Z",
    transform: "translate(-559.736 -196.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fl",
    d: "M555.479,256.47l-2.485,2.988.294.083,3.3-1.572.289-.4-.5.02.185-.649-.8-.1.25-.524Z",
    transform: "translate(-552.994 -239.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fm",
    d: "M553.614,265.2l.249.554-.574.274-.294-.083Z",
    transform: "translate(-552.994 -246.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fn",
    d: "M635.288,197.6l.315.726.8,1.088.5.378.6-.445-1.637-2.208Z",
    transform: "translate(-613.122 -196.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fo",
    d: "M637.443,195.5l.227.659.842,1.142.569.407.923-.956s-.084-.819-1.367-1.856Z",
    transform: "translate(-614.697 -194.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fp",
    d: "M585.974,203.823l-20.436,15.411.5-.019-.289.4,20.793-15.381Z",
    transform: "translate(-562.16 -201.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fq",
    d: "M555.479,213.227l-2.485,2.988.164.046,2.724-2.753L575.967,197.8l-.227-.659Z",
    transform: "translate(-552.994 -196.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fr",
    d: "M641.871,194.9a2.892,2.892,0,0,0,1.367,1.856A2.7,2.7,0,0,0,641.871,194.9Z",
    transform: "translate(-617.932 -194.896)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.466 92.792)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fs",
    d: "M625.584,283.336l-1.735,8.7a21.772,21.772,0,0,1-3.908.256c-4.116-.059-10.645-1.118-15.388-6.494l2.61-6.122.606-1.419Z",
    transform: "translate(-600.846 -271.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M632.664,283.336l-1.735,8.7a21.772,21.772,0,0,1-3.908.256c-3.518-6.3-12.778-12.616-12.778-12.616l.606-1.419Z",
    transform: "translate(-607.926 -271.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ft",
    d: "M590.892,254.416l-.1.527,11.585,10.929,23.664,3.494.359-.8Z",
    transform: "translate(-590.79 -254.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "eo",
    d: "M591.169,254.416l21.359,3.864,14.147,10.281-23.349-3.616Z",
    transform: "translate(-591.067 -254.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M633.8,294.436l.673-.926,23.349,3.616-.359.8Z",
    transform: "translate(-622.217 -282.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "M712.109,328.4c-.339,1.247-1.013,1.481-1.013,1.481a21.659,21.659,0,0,1-5.1-3.679l-.038-.035-.057-.054-.151-.143c.081.078.159.159.237.234.054.057.11.11.17.167l.057.057a33.848,33.848,0,0,0,4.447,3.857l-.539.337a45.208,45.208,0,0,1-5.578-5.508.413.413,0,0,0,.032.043,30.088,30.088,0,0,0,2.206,2.7c.043.048.086.1.129.143.143.154.28.3.417.45l.089.094c.038.038.073.075.113.113l.008.011c1.22,1.277,2.179,2.12,2.179,2.12-2.761,1.953-4.8,1.659-4.8,1.659a14.219,14.219,0,0,1-1.527-7.35,2.521,2.521,0,0,1-1.414-1.592,1.822,1.822,0,0,1,.434-1.473c.929.3,1-.374,1-.374a2.5,2.5,0,0,1,1.605,1.67.165.165,0,0,1,.005.027c0,.016.006.042.01.072a1.753,1.753,0,0,1-.12.951c0,.005,0,.008-.005.013l.178.159A22.424,22.424,0,0,0,712.109,328.4Z",
    transform: "translate(-672.005 -303.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M651.769,278.259l12.083,6.886v.65l1.268.188.163-1.036Z",
    transform: "translate(-635.344 -271.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "M651.769,277.406l.784-.315,13.388,6.87s-.107,4.055.805,5.135c0,0,.3.941-1,.374,0,0,.145-.071-.885-5Z",
    transform: "translate(-635.344 -270.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M716.428,337.967c-.027-.027-.051-.054-.075-.081l.132.135.038.035.162.17c-.059-.057-.116-.11-.17-.167C716.485,338.026,716.455,338,716.428,337.967Z",
    transform: "translate(-682.533 -315.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fu",
    d: "M704.022,329.857a20.093,20.093,0,0,0,.972,7.119,14.22,14.22,0,0,1-1.527-7.35,2.521,2.521,0,0,1-1.414-1.592,1.679,1.679,0,0,0,1.7,1.032,1.435,1.435,0,0,0,1.339-1.209.176.176,0,0,1,.005.027,2.01,2.01,0,0,1-.11,1.024c0,.005,0,.008-.005.013l.178.159H704.9a4.539,4.539,0,0,0,.991,1.46l-1.226-1.255-.253.121.2.221a.059.059,0,0,0,.011.013.439.439,0,0,0,.032.043c.218.288,1.218,1.592,2.206,2.7.043.048.086.1.129.143q.178.2.355.388l-3.122-3.208Z",
    transform: "translate(-672.085 -308.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M604.553,306.256s6.646,7.4,19.3,6.238C623.849,312.494,612.357,314.757,604.553,306.256Z",
    transform: "translate(-600.846 -292.293)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetreadyforexam);
export default __webpack_public_path__ + "static/media/getreadyforexam.89c0e6e1b4b9e517d9918b723fab0fa3.svg";
export { ForwardRef as ReactComponent };